<template>
  <div class="container-fluid"> 
    <div class="loading-state" v-if="loading_d">
            <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="homeTab" class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
                <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button"
                    role="tab" aria-controls="tab1" aria-selected="true" @click="onClickTab('1')">
                    {{ $t("content.amngroupticket") }}
                </button>
            </li>

            <li class="nav-item" role="presentation">
                <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button"
                    role="tab" aria-controls="tab2" aria-selected="false" @click="onClickTab('2')">
                    {{ $t("content.amnticketmanage") }}
                </button>
            </li>
        </ul>

        <div id="dfTabContent" class="tab-content">
            <div id="tab1" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tab1-tab">
                <div class="card mt-2"> 
                    <div class="card-header mb-0">
                      <h5>{{ $t("content.amnticketlist") }}</h5>
                    </div>
                    <div class="card-body pt-2">
                        <div class="row">
                            <div class="col-lg-3 mt-0">
                                        <fieldset>
                                            <div class="item">
                                                <material-checkbox v-model="time" :checked="time" name="autoSelect"
                                                    @change="onserachDate">
                                                    <label class="form-label m-0">{{ $t("content.sdate") }} ({{$t("content.mgtpawndate")}})</label>
                                                </material-checkbox>
                                                <VueDatePicker v-model="start_date" :format="format" auto-apply
                                                    :teleport="true" :max-date="new Date().setHours(23, 59, 59)"
                                                    :enable-time-picker="true" month-name-format="long"
                                                    :clearable="false" fluid :disabled="!time"
                                                    :text-input="textInputOptions" />
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                                        <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                                            :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true"
                                            month-name-format="long" :clearable="false" :text-input="textInputOptions"
                                            :disabled="!time" fluid />
                                    </div>
                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.names") }}</label>
                                        <div class="input-group">
                                            <input v-model="cusName_search" type="text" class="form-control"
                                                aria-describedby="searchName" readonly />
                                            <button class="btn btn-primary" type="button" @click="openDialogCusS">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                            </button>
                                            <button id="searchNameCus" class="btn btn-primary" type="button"
                                                data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 mt-2">
                                        <label class="form-label ms-0">{{ $t("content.ticketno") }} ({{ $t("content.factoryno") }})</label>
                                        <material-input type="text" v-model="tk_search" />
                                    </div>
                        </div>
                        <div class="row mt-4">
                                    <div class="col-3 d-flex justify-content-between align-items-center"></div>
                                    <div class="col-9 d-flex justify-content-end align-items-center">
                                        <div class="me-3">
                                            <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                                                @click="loadListApi" :disabled="(!time && cusName_search === '' && tk_search === '') || (time && start_date > end_date)">
                                                <i class="material-icons material-symbols-outlined">search</i>
                                                {{ search }}
                                            </material-button>
                                        </div>
                                        <div class="me-3">
                                            <material-button color="danger" class="float-lg-start float-sm-end mb-3"
                                                @click="cancelBtn">
                                                <i class="material-icons material-symbols-outlined">close</i>
                                                {{ cancel }}
                                            </material-button>
                                        </div>
                                    </div>
                        </div>
                        <hr />
                        <pre></pre>
                        <div class="row mt-3">
                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>{{ $t("content.transdate") }}</th>
                                                    <th>{{ $t("content.amnduedate") }}</th>
                                                    <th>{{ $t("content.tkOwner") }}</th>
                                                    <th>{{ $t("content.ticketno") }} ({{ $t("content.factoryno") }})</th>
                                                    <th>{{ $t("content.amnbookno") }}</th>
                                                    <th>{{ $t("content.amnno") }}</th>
                                                    <th>{{ $t("content.trans") }}</th>
                                                    <th>{{ $t("content.amnqtyunitall") }}</th>
                                                    <th>{{ $t("content.amnhdanalysall") }}</th>
                                                    <th>{{ $t("content.amnmaxvalall") }}</th>
                                                    <th>{{ $t("content.act") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                <tr v-for="(row, index) in listdata" :key="index">
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberString((currentPage - 1) * perPage + index
                                                            + 1)
                                                        }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_datetime(row.pawnDate) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ format_date(row.dueDate) }}
                                                    </td>    
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkCusName }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkRefNumber }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkVolNo }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ row.tkNo }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ checkTransaction(row.txType) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberString(row.quantity) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        {{ formatNumberDecimalString(row.pawnValue) }}
                                                    </td>
                                                     <td class="text-sm font-weight-normal">
                                                        {{ formatNumberDecimalString(row.fullValue) }}
                                                    </td>
                                                    <td class="text-sm font-weight-normal">
                                                        <material-button color="primary" variant="outline" class="rounded-circle"
                                                            @click="openGallery(row.images)" :disabled="row.images.length === 0">
                                                            <i class="material-icons material-symbols-outlined">photo_library</i>
                                                        </material-button>
                                                        <material-button color="warning" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                                                            data-bs-target="#lookupModal" id="myModalClose" v-show="false">
                                                        </material-button>
                                                        <material-button id="a" color="info" variant="outline" class="rounded-circle"
                                                            data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amnticketmanage')"
                                                            @click="openTab(row.uid)">
                                                            <i class="material-icons material-symbols-outlined">edit</i>
                                                        </material-button>
                                                        <material-button color="danger" variant="outline" class="rounded-circle"
                                                            data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.dele')"
                                                            @click="onDeleteDialog(row)">
                                                            <i class="material-icons material-symbols-outlined">close</i>
                                                        </material-button>
                                                    </td>
                                                </tr>
                                                <tr v-if="listdata.length === 0">
                                                    <td colspan="12" class="text-sm font-weight-normal">
                                                        <p style="text-align: center">No Record Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="15" style="text-align: right">Total Rows : {{
                                                        totalRows_s}}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                <pre></pre>
                                <div style="display: flex; justify-content: flex-end">
                                    <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                                        <div class="project-container">
                                            <div class="example-one">
                                                <vue-awesome-paginate v-model="currentPage" :total-items="totalRows"
                                                    :items-per-page="perPage" @click="onClickHandler" />
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                    </div>
                </div>
            </div>

            <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
                <div class="card mt-2">
                    <div class="card-header mb-0">
                        <h5>{{ $t("content.persontinfo") }}</h5>
                    </div>
                    <div class="card-body pt-2">
                        <div class="row">
                          <div class="col-lg-6">
                            <label class="form-label ms-0">{{ $t('content.cnam') }} - {{ $t('content.clsnam')
                              + " (" + $t("content.th") + ")" }}
                              <span class="text-primary">
                                <b>*{{ $t('content.tkcusname') }}</b>
                              </span>
                            </label>
                            <div class="input-group">
                                <input v-model="cusNamed_search" type="text" class="form-control"
                                  aria-describedby="searchName" readonly />
                                <button class="btn btn-primary" type="button" @click="openDialogCusD">
                                  <i class="material-icons material-symbols-outlined">search</i>
                                </button>
                                <button id="searchNameCus" class="btn btn-primary" type="button"
                                  data-bs-toggle="modal" data-bs-target="#searchNameModal" v-show="false">
                                </button>
                            </div>
                          </div>

                          <div class="col-lg-6">
                            <label class="form-label ms-0">{{ $t('content.cnam') }} - {{ $t('content.clsnam')
                              + " (" + $t("content.en") + ")" }}</label>
                            <material-input v-model="cus_detail.nameEn" type="text" disabled />
                          </div>

                          <div class="col-lg-3">
                            <label class="form-label ms-0">{{ $t("content.cmobile") }}1
                              <span class="text-danger">
                              <b>*</b>
                              </span>
                            </label>
                            <span v-if="cus_detail.cusShop !== null">
                              <InputMask v-model="cus_detail.cusShop.phoneNo1" mask="(999) 999-9999" fluid />
                            </span>
                            <span v-else>
                              <material-input type="text" disabled />
                            </span>
                          </div>

                          <div class="col-lg-3">
                            <label class="form-label ms-0">{{ $t("content.cmobile") }}2</label>
                            <span v-if="cus_detail.cusShop !== null">
                              <InputMask v-model="cus_detail.cusShop.phoneNo2" mask="(999) 999-9999" fluid />
                            </span>
                            <span v-else>
                              <material-input type="text" disabled />
                            </span>
                          </div>

                          <div class="col-lg-3">
                            <label class="form-label ms-0">{{ $t("content.cmobile") }}3</label>
                            <span v-if="cus_detail.cusShop !== null">
                              <InputMask v-model="cus_detail.cusShop.phoneNo3" mask="(999) 999-9999" fluid />
                            </span>
                            <span v-else>
                              <material-input type="text" disabled />
                            </span>
                          </div>


                          <div class="col-lg-3">
                            <label class="form-label ms-0"></label>
                            <div class="flex flex-wrap justify-center gap-4">
                              <div class="flex items-center d-inline-block">
                                 <span v-if="cus_detail.cusShop !== null">
                                    <material-checkbox id="asGroup" v-model="cus_detail.cusShop.notifyWarning"
                                      :checked="cus_detail.cusShop.notifyWarning">
                                      {{ $t("content.cenanoti") }}
                                    </material-checkbox>
                                 </span>
                                  <span v-else>
                                      <material-checkbox id="asGroup" disabled>
                                        {{ $t("content.cenanoti") }}
                                      </material-checkbox>
                                  </span>
                              </div>
                            </div>
                          </div>
                          <pre></pre>

                          <div class="col-lg-10" >
                           <span v-if="cus_detail.cusShop !== null">
                              <label class="form-label ms-0">
                                <span v-if="cus_detail.cusShop.warningMsg !== null">
                                  {{ $t('content.cexintra') }} ( {{ $t('content.cchacount') }} {{
                                    cus_detail.cusShop.warningMsg.length }} / 100)
                                </span>
                                <span v-else>
                                  {{ $t('content.cexintra') }} ( {{ $t('content.cchacount') }} 0 / 100)
                                </span>
                              </label>
                              <input v-model="cus_detail.cusShop.warningMsg" type="text" class="form-control" autocomplete="off"
                                style="margin-bottom:0 !important" aria-describedby="searchRelation" maxlength="100">
                            </span>
                            <span v-else>
                               <label class="form-label ms-0">
                                  {{ $t('content.cexintra') }} ( {{ $t('content.cchacount') }} 0 / 100)
                               </label>
                               <input  type="text" class="form-control" autocomplete="off"
                                style="margin-bottom:0 !important" aria-describedby="searchRelation" maxlength="100" disabled>
                            </span>
                             
                          </div>


                          <div class="col-lg-1 col-sm-3">
                            <label class="form-label ms-0 png"></label>
                            <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                              @click="toggleInfo">
                              <i v-if="datas.hide" class="material-icons material-symbols-outlined">expand_less</i>
                              <i v-else class="material-icons material-symbols-outlined">expand_more</i>
                            </material-button>
                          </div>

                          <div class="col-lg-1 col-sm-3">
                            <label class="form-label ms-0 png"></label>
                            <material-button color="primary" class="float-lg-start float-sm-end mb-3" :disabled="cus_detail.cusShop === null || cus_detail.cusShop.phoneNo1 === null
                              || cus_detail.uid === '' "
                              @click="updateCustomerShop('data')" :title="t('buttons.save') + $t('content.gcustomer')">
                              <i class="material-icons material-symbols-outlined">save</i>
                            </material-button>
                          </div>
                      </div>


                      <div v-if="datas.hide" class="row">
                        <div class="col-lg-3 col-sm-4">
                          <label class="form-label ms-0">{{ $t('content.cardtype') }}</label>
                          <select class="form-select" v-model="cus_detail.docTypeUid" disabled>
                            <option value="0" disabled selected>{{ $t('content.select') }}</option>
                            <option v-for="(item, index) in doctypeAccList" :value="item.uid" :key="index">
                              {{ item.name }}
                            </option>
                          </select>
                        </div>
                        <div class="col-lg-5 col-sm-5">
                          <label class="form-label ms-0">{{ $t('content.cardno') }}</label>
                          <material-input type="text" v-model="cus_detail.docNumber" disabled />
                        </div>

                        <div class="col-lg-3 col-sm-5">
                          <label class="form-label ms-0"> {{ $t("content.noexp") }}</label>
                          <div class="flex flex-wrap justify-center gap-4">
                            <div class="flex items-center d-inline-block">
                              <material-checkbox v-model="cus_detail.lifetime" :checked="cus_detail.lifetime" disabled>
                              </material-checkbox>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-4">
                          <label class="form-label ms-0">{{ $t('content.pcissue') }}</label>
                          <material-input v-model="cus_detail.issuedBy" type="text" disabled />
                        </div>
                        <div class="col-lg-3">
                          <label class="form-label ms-0">{{ $t('content.cdissue') }}</label>
                          <div class="flex justify-center">
                            <VueDatePicker v-model="cus_detail.issuedDate" :format="format" :max-date="new Date()" auto-apply
                              :enable-time-picker="false" month-name-format="long" :clearable="false" fluid disabled />
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <label class="form-label ms-0">{{ $t('content.cdexpire') }}</label>
                          <VueDatePicker v-model="cus_detail.expiredDate" :format="format" :min-date="new Date()" auto-apply
                            :enable-time-picker="false" month-name-format="long" :clearable="false" fluid disabled />
                        </div>
                      </div>


                      <div v-if="datas.hide" class="row">
                        <div class="col-lg-3">
                          <label class="form-label ms-0">{{ $t('content.cbirth') }}</label>
                          <VueDatePicker v-model="cus_detail.birthOrRegDate" :format="format" :max-date="new Date()"
                            auto-apply :enable-time-picker="false" month-name-format="long" :clearable="false" fluid disabled
                            @update:model-value="inputBirthday" />
                        </div>
                        <div class="col-lg-2">
                          <label class="form-label ms-0">{{ $t('content.cage') }}</label>
                          <material-input v-model="cus_detail.age" type="text" disabled />
                        </div>
                        <div class="col-lg-3">
                          <label class="form-label ms-0">{{
                            $t("content.amntypecustomer")
                          }}</label>
                          <span v-if="cus_detail.cusShop !== null">
                            <select class="form-select" v-model="cus_detail.cusShop.cusTypeUid" disabled>
                              <option value="0" disabled selected>{{ $t('content.select') }}</option>
                              <option v-for="(item, index) in custypeList" :value="item.uid" :key="index">
                                {{ item.name }}
                              </option>
                            </select>
                          </span>
                          <span v-else>
                            <select class="form-select" disabled>
                              <option value="0" disabled selected>{{ $t('content.select') }}</option>
                              <option v-for="(item, index) in custypeList" :value="item.uid" :key="index">
                                {{ item.name }}
                              </option>
                            </select>
                          </span>

                        </div>
                        <div class="col-lg-3">
                          <label class="form-label ms-0">{{ $t("content.amncredit") }}</label>
                          <span v-if="cus_detail.cusShop !== null">
                            <InputNumber v-model="cus_detail.cusShop.creditAmount" autocomplete="off" disabled fluid />
                          </span>
                          <span v-else>
                            <material-input type="text" disabled />
                          </span>
                        </div>
                      </div>

                      <div v-if="datas.hide" class="row">
                        <div class="col-8 mt-2">
                          <label class="form-label ms-0">{{ $t('content.caddress') }} ({{ $t('content.docaddress') }})</label>
                          <material-input v-model="cus_detail.address.address1" type="text" disabled />
                        </div>
                        <div class="col-lg-4 mt-2">
                          <label class="form-label ms-0">{{ $t('content.add1') }}</label>
                          <div class="input-group">
                            <Select v-model="cus_detail.address.country" :options="listCountry" filter optionLabel="nameTh"
                              placeholder="กรุณาเลือกประเทศ" class="w-full md:w-56" style="width:650px;" resetFilterOnHide
                              disabled>
                              <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex items-center">
                                  <div>{{ slotProps.value.nameTh }}</div>
                                </div>
                                <span v-else>
                                  {{ slotProps.placeholder }}
                                </span>
                              </template>
                              <template #option="slotProps">
                                <div class="flex items-center">
                                  <div>{{ slotProps.option.nameTh }}</div>
                                </div>
                              </template>
                            </Select>
                          </div>
                        </div>


                        <div class="col-lg-4 mt-2">
                          <label class="form-label ms-0">{{ $t('content.cstate') }}</label>
                          <div class="input-group">
                            <Select v-model="cus_detail.address.province" :options="listProvince" filter optionLabel="nameTh"
                              placeholder="กรุณาเลือกจังหวัด" class="w-full md:w-56" style="width:450px;" resetFilterOnHide
                              disabled>
                              <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex items-center">
                                  <div>{{ slotProps.value.nameTh }}</div>
                                </div>
                                <span v-else>
                                  {{ slotProps.placeholder }}
                                </span>
                              </template>
                              <template #option="slotProps">
                                <div class="flex items-center">
                                  <div>{{ slotProps.option.nameTh }}</div>
                                </div>
                              </template>
                            </Select>
                          </div>
                        </div>
                        <div class="col-lg-4 mt-2">
                          <label class="form-label ms-0">{{ $t('content.csprov') }}</label>
                          <div class="input-group">
                            <Select v-model="cus_detail.address.district" :options="listDistrict" filter optionLabel="nameTh"
                              placeholder="กรุณาเลือกเขต/อำเภอ" class="w-full md:w-56" style="width:450px;" resetFilterOnHide
                              disabled>
                              <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex items-center">
                                  <div>{{ slotProps.value.nameTh }}</div>
                                </div>
                                <span v-else>
                                  {{ slotProps.placeholder }}
                                </span>
                              </template>
                              <template #option="slotProps">
                                <div class="flex items-center">
                                  <div>{{ slotProps.option.nameTh }}</div>
                                </div>
                              </template>
                            </Select>
                          </div>
                        </div>
                        <div class="col-lg-4 mt-2">
                          <label class="form-label ms-0">{{ $t('content.cscity') }}</label>
                          <div class="input-group">
                            <Select v-model="cus_detail.address.subDistrict" :options="listSubDistrict" filter
                              optionLabel="nameTh" placeholder="กรุณาเลือกแขวง/ตำบล" class="w-full md:w-56"
                              style="width:450px;" resetFilterOnHide disabled>
                              <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex items-center">
                                  <div>{{ slotProps.value.nameTh }}</div>
                                </div>
                                <span v-else>
                                  {{ slotProps.placeholder }}
                                </span>
                              </template>
                              <template #option="slotProps">
                                <div class="flex items-center">
                                  <div>{{ slotProps.option.nameTh }}</div>
                                </div>
                              </template>
                            </Select>
                          </div>
                        </div>

                        <div class="col-8 mt-2">
                          <label class="form-label ms-0">{{ $t('content.cemail') }}</label>
                          <span v-if="cus_detail.cusShop !== null">
                            <material-input v-model="cus_detail.cusShop.email" type="email" />
                          </span>
                          <span v-else>
                            <material-input disabled />
                          </span>
                        </div>
                      </div>
                  </div>
                </div>

                <div class="card mt-2">
                  <div class="card-header">
                    <h5>{{ $t("content.tkdetail") }}</h5>
                  </div>
                  
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.transdate") }} 
                              <span class="text-success" v-if="tk_detail.pawnDate !== null">
                               ({{formatDateTimeToBE(tk_detail.pawnDate)}})
                              </span>
                            </b>
                          </span>
                         </label>
                          <VueDatePicker v-model="tk_detail.pawnDate" :format="formatpd" auto-apply :teleport="true" 
                          :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" @update:model-value="addMonths()"
                          month-name-format="long" :clearable="false" :text-input="textInputOptionspd" 
                          fluid  />
                      </div>

                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amnduedate") }}
                              <span class="text-success" v-if="tk_detail.dueDate !== null">
                               ({{formatDateToBE(tk_detail.dueDate)}})
                              </span>
                            </b>
                          </span>
                         </label>
                          <VueDatePicker v-model="tk_detail.dueDate" :format="formatd" auto-apply :teleport="true"
                          :min-date="new Date(tk_detail.pawnDate)" :enable-time-picker="false" 
                          month-name-format="long" :clearable="false" :text-input="textInputOptionsd" 
                          fluid />
                      </div>

                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.trans") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                         </label>
                         <select v-model="tk_detail.txType" class="form-select" @change="calItems()">
                            <option value="" disabled selected>{{ $t('content.select') }}</option>
                            <option v-for="(item, index) in tx_list" :value="item.code" :key="index">
                            {{ item.name }}
                            </option>
                          </select>
                      </div>

                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.ticketno") }} ({{ $t("content.factoryno") }})</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <material-input v-model="tk_detail.tkRefNumber" type="text" @input="onlyDigits('tkRefNumber')"/>
                      </div>

                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amnbookno") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <material-input v-model="tk_detail.tkVolNo" type="text" @input="onlyDigits('tkVolNo')"/>
                      </div>

                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amnno") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <material-input v-model="tk_detail.tkNo" type="text" @input="onlyDigits('tkNo')"/>
                      </div>

                      
                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.booknotkbefo") }}</b>
                          </span>
                        </label>
                        <material-input v-model="tk_detail.prevTkVolNo" type="text" @input="onlyDigits('prevTkVolNo')"/>
                      </div>

                      <div class="col-4 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amntkbefo") }}</b>
                          </span>
                        </label>
                        <material-input v-model="tk_detail.prevTkNo" type="text" @input="onlyDigits('prevTkNo')"/>
                      </div>
                    </div>

                    <div class="row">

                      <div class="col-3 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amnqtyunitall") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <InputNumber v-model="tk_detail.quantity" autocomplete="off"
                          @focus="$event.target.select()" fluid @update:modelValue="calItems()"/>
                      </div>


                      <div class="col-3 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amnhdanalysall") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <InputNumber v-model="tk_detail.pawnValue" :minFractionDigits="0" :maxFractionDigits="2"
                          autocomplete="off" @focus="$event.target.select()" fluid @update:modelValue="calItems()"/>
                      </div>

                      <div class="col-3 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.amnmaxvalall") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <InputNumber v-model="tk_detail.fullValue" :minFractionDigits="0" :maxFractionDigits="2"
                          autocomplete="off" @focus="$event.target.select()" fluid @update:modelValue="calItems()"/>
                      </div>

                      
                      <div class="col-3 mt-2">
                        <label class="form-label ms-0">
                          <span class="text-info">
                            <b>{{ $t("content.cintrate") }}</b>
                          </span>
                          <span class="text-danger">
                          <b>*</b>
                          </span>
                        </label>
                        <InputNumber v-model="tk_detail.interest" :minFractionDigits="0" :maxFractionDigits="2"
                          autocomplete="off" @focus="$event.target.select()" fluid @update:modelValue="calItems()" />
                      </div>
                    </div>

                    <pre></pre> <pre></pre> <pre></pre>
                    <hr />
                    <pre></pre>

                    <div class="row mt-4 no-gutters">
                     <div class="col-8 d-flex justify-content-end align-items-center">
                      <div class="left">
                        <div class="me-2">
                          <h6>
                            <b>{{ $t("content.amnassetdatas") }}</b>
                          </h6>
                        </div>
                      </div>
                    </div>

                    <div class="col-4 d-flex justify-content-end align-items-center">
                      <div class="me-2">
                       <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                          :disabled="tk_detail.images.length === 0" @click="openGallery(tk_detail.images)">
                          <i class="material-icons material-symbols-outlined">photo_library</i>
                          {{ $t("content.viewimg") }}
                        </material-button>
                        <material-button color="warning" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                          data-bs-target="#lookupModal" id="myModalClose" v-show="false">
                          <i class="material-icons material-symbols-outlined">photo_library</i>
                          {{ $t("content.viewimg") }}
                        </material-button>
                      </div>
                      <div class="me-2">
                        <material-button id="saveTicket" color="primary" class="float-lg-start float-sm-end mb-3"
                          :disabled="cus_detail.cusShop === null || listQ02D.length >= 8 || parseFloat(balprice) === 0 || parseFloat(balquanity) === 0 "
                          @click="showModal">
                          <i class="material-icons material-symbols-outlined">add</i>
                            {{ $t("content.amnaddnew") }}
                        </material-button>
                      </div>
                      <material-button color="primary" class="float-lg-start float-sm-end mb-0" data-bs-toggle="modal"
                        data-bs-target="#newPawnListModal" id="newPawnModal" v-show="false" />
                      <material-button color="primary" class="float-lg-start float-sm-end mb-0" data-bs-toggle="modal"
                        data-bs-target="#viewPawnListModal" id="viewPawnModal" v-show="false" />
                    </div>
                  </div>


                  <div class="row mt-4">
                    <div class="table-responsive">
                      <table class="table table-flush">
                        <thead class="thead-light">
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.amnassetgroup") }}</th>
                            <th>{{ $t("content.amnweightval") }}</th>
                            <th>{{ $t("content.amnqtyunit") }}</th>
                            <th>{{ $t("content.amnanalysval") }}</th>
                            <th>{{ $t("content.amnmaxval") }}</th>

                            <th>{{ $t("content.act") }}</th>
                          </tr>
                        </thead>

                        <tbody v-if="listQ02D.length === 0">
                          <tr>
                            <td colspan="10" class="text-sm font-weight-normal">
                              <p style="text-align: center">No Record Found</p>
                           </td>
                          </tr>
                        </tbody>
                        <tbody v-else v-for="(row, index) in listQ02D" :key="index" :data-group-index="index">
                          <tr  class="group-id-ticket" :class="row.st == 'finished' ? '' : 'bg-working'">
                            <td class="text-sm font-weight-normal">{{ formatNumberString(index + 1) }}</td>
                            <td class="text-sm font-weight-normal">{{ filterCat(row.mainCatUid) }}</td>
                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight)
                            }}
                            </td>
                            <td class="text-sm font-weight-normal">{{ formatNumberString(row.quantity) }}</td>
                            <td class="text-sm font-weight-normal">
                              {{ formatNumberDecimalString(row.pawnValue) }}
                            </td>
                            <td class="text-sm font-weight-normal">{{
                              formatNumberDecimalString(row.fullValue) }}
                            </td>
                            <td class="text-sm font-weight-normal">
                              <material-button  color="info" variant="outline"
                                class="rounded-circle" data-bs-toggle="tooltip" data-bs-placement="top" :title="edit"
                                @click="onSelectCollect(row,index)">
                                <i class="material-icons material-symbols-outlined">edit</i>
                              </material-button>
                              <material-button  color="danger" variant="outline"
                                class="rounded-circle" data-bs-toggle="tooltip" data-bs-placement="top" :title="cancel"
                                @click="deleteItems(index)">
                                <i class="material-icons material-symbols-outlined">delete</i>
                              </material-button>
                            </td>
                          </tr>
                          <tr v-for="(j, set1) in row.remarkL" :key="set1">
                            <td class="text-sm font-weight-normal text-end" colspan="3">
                              <span style="text-decoration:underline">
                                {{ $t("content.amnassetdetail") }}
                              </span>
                            </td>
                            <td class="text-sm font-weight-normal" colspan="7">
                              <span style="color:red">
                                <b>{{ j.val }}</b>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <pre></pre>
                  <hr />

                  <div class="row mt-4">
                    <div class="col-3 d-flex justify-content-between align-items-center">
                      <material-button color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelMgt">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ cancel }}
                      </material-button>
                    </div>

                    <div class="col-9 d-flex justify-content-end align-items-center">
                      <div class="me-3">
                        <material-button id="capImage" color="info" class="float-lg-start float-sm-end mb-3"
                          :disabled="parseFloat(balprice) !== 0 || parseFloat(balfull) !== 0 || parseFloat(balquanity) !== 0 || cansave || listQ02D.length === 0" 
                          @click="onImgDialog">
                          <i class="material-icons material-symbols-outlined">add_a_photo</i>
                          {{ $t("content.tupload") }}
                        </material-button>
                        <material-button color="primary" variant="outline" class="rounded-circle" data-bs-toggle="modal"
                          data-bs-target="#attachmentsModal" v-show="false" id="attachmenDialog">
                        </material-button>
                      </div>


                      <div class="me-3">
                        <material-button id="saveTicket" color="primary" class="float-lg-start float-sm-end mb-3"
                          :disabled="cus_detail.cusShop === null || parseFloat(balprice) !== 0 || parseFloat(balfull) !== 0 || parseFloat(balquanity) !== 0
                          || cansave || listQ02D.length === 0  || (tk_detail.images.length === 0 && thumb === null && photoFile.length === 0)"
                          @click="saveMgt">
                          <i class="material-icons material-symbols-outlined">save</i>
                         {{ $t("buttons.save") }}
                        </material-button>

                      </div>
                    </div>
                  </div>



                  </div>

                </div>

                


            </div>
        </div>

        <NewCamera v-if="hideCam" v-model="hideCam" @close="closeCamera" @save="savephotoTaken" />

        <!-- Search Customer Dialog -->
        <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="preview-table">
                  <section class="panel">
                    <table class="table table-striped table-responsive">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.cnameth") }}</th>
                          <th>{{ $t("content.cnameen") }}</th>
                          <th>{{ $t("content.docnum") }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row-search">
                            <td></td>
                            <td>
                              <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                            </td>
                            <td>
                              <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                            </td>
                            <td>
                              <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                            </td>
                            <td>
                              <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                @click="loadCustomerListApi">
                                <i class="material-icons material-symbols-outlined">search</i>
                              </material-button>
                            </td>
                          </tr>
                        <tr v-for="(row, index) in customerlist" :key="index" @click="selectCus(row)">
                          <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                          <td>{{ row.nameTh }}</td>
                          <td>{{ row.nameEn }}</td>
                          <td colspan="2">{{ row.docNumber }}</td>
                        </tr>
                        <tr v-if="customerlist.length === 0">
                          <td colspan="5" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>

              <div class="modal-footer">
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                          :items-per-page="perPageC" @click="onClickHandlerC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Gallery Modal -->
        <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                  <div class="carousel-indicators">
                    <div class="carousel-indicators" id="demo1">
                    </div>
                  </div>
                  <div class="carousel-inner">
                    <ul className="list-unstyled">
                      <li v-for="(item, index) in images.length" :key="index">
                        <span v-if="index === 0">
                          <div class="carousel-item active">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                        <span v-else>
                          <div class="carousel-item">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Add New List in Pawn Ticket Dialog -->
        <div id="newPawnListModal" class="modal fade" aria-labelledby="newPawnListModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.amnsplitlist") }} </h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <fieldset>
                  <div class="row">
                    <div class="col-lg-4">
                      <label class="form-label ms-0">{{
                        $t("content.amnassetgroup")
                      }}</label>
                      <select v-model="collect_detail.mainCatUid" class="form-select" disabled>
                        <option value="0" selected disabled>{{ $t("content.select") }}</option>
                        <option v-for="(item, index) in listprint" :value="item.uid" :key="index">
                          {{ item.name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-8">
                      <label class="form-label ms-0">
                        {{ $t("content.amnassetgroup") }}
                        <span v-if="typesNew.length > 0">
                          ({{ textt }})
                        </span>
                      </label>
                      <div ref="parentRef" class="cs-auto-input">
                        <input id="inp" v-model="filterText" ref="input" placeholder="ค้นหาประเภททรัพย์..."
                          class="form-control auto-input-search" list="assetOptions" @input="newformatinput"
                          autocomplete="off" type="search">
                        <ul id="myList" v-if="dataList.length > 0 && filterText.length > 0" ref="list" class="data-list"
                          :style="`width: ${childWidth}px !important;`" @scroll="handleScroll">
                          <li v-for="(item, index) in dataList" :key="index" @click="selection(item)">
                            <a>{{ item.datailt }}</a>
                          </li>
                          <li v-if="loading">Loading...</li>
                          <p v-if="dataList.length" id="load-more" :class="loadMoreStatus"></p>
                        </ul>
                      </div>
                    </div>

                    <div class="row flex flex-wrap p-fluid">

                      <div class="flex-auto col-lg-4">
                        <label class="form-label ms-0">{{ $t("content.amnqtyunittick") }} </label>
                        <InputNumber v-model="collect_detail.quantity" autocomplete="off"
                          @focus="$event.target.select()" fluid @update:modelValue="setRemark()" />

                      </div>


                      <div class="flex-auto col-lg-2">
                        <label class="form-label ms-0">{{ $t("content.munit") }}</label>
                        <select v-model="collect_detail.unitUid" class="form-select" @change="setRemark">
                          <option value="0" selected disabled>{{ $t("content.select") }}</option>
                          <option v-for="(item, index) in listunit" :value="item.uid" :key="index">
                            {{ item.name }}
                          </option>
                        </select>
                      </div>

                      <div class="flex-auto col-lg-6">
                        <label class="form-label ms-0">Serial Number</label>
                        <material-input id="serialPawn" v-model="collect_detail.serialNumber" autocomplete="off"
                          @update:modelValue="setRemark()" />
                      </div>

                    </div>

                    <div class="row flex flex-wrap p-fluid">
                      <div class="flex-auto col-lg-4">
                        <label class="form-label ms-0">{{ $t("content.amnhdweightall") }}</label>
                        <InputNumber v-model="collect_detail.weight" :minFractionDigits="0" :maxFractionDigits="2"
                          autocomplete="off" @focus="$event.target.select()" fluid @update:modelValue="setRemark()" />
                      </div>


                      <div class="col-lg-4">
                        <label class="flex-auto form-label ms-0">{{ $t("content.amnanalysval") }}</label>
                        <InputNumber v-model="collect_detail.pawnValue" :minFractionDigits="0" :maxFractionDigits="2"
                          autocomplete="off" @focus="$event.target.select()" fluid />

                      </div>

                      <div class="flex-auto col-lg-4">
                        <label class="form-label ms-0">{{ $t("content.amnmaxval") }}</label>
                        <InputNumber v-model="collect_detail.fullValue" :minFractionDigits="0" :maxFractionDigits="2"
                          autocomplete="off" @focus="$event.target.select()" fluid />
                      </div>
                    </div>

                    <div class="flex flex-wrap p-fluid mt-2">
                      <div class="flex-auto col-lg-4">
                        <label class="flex-auto form-label ms-0">
                          {{ $t("content.ticketdetail") }}
                        </label>

                        <small class="form-label ms-2" style="color:red;">
                          <span @click="selectFlaw()" style="text-decoration: underline;color:red; cursor: pointer">
                            {{ $t("content.defect") }}
                          </span>
                        </small>
                      </div>
                      <div class="card mb-3" v-if="openFlaw">
                        <Panel>
                          <template #header>
                            <span> <label class="flex-auto form-label ms-0">{{ $t("content.select") }} {{
                              $t("content.defect") }}</label></span>
                          </template>
                          <template #icons>
                            <Button severity="secondary" rounded text class="btnClose" @click="selectFlaw()">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </Button>
                          </template>
                          <template #footer>
                            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                              <button class="btn btn-primary btn-sm" type="button" @click="flawSelection()"> 
                                {{ $t("buttons.save") }}</button>
                            </div>
                          </template>
                          <div class="grid-container">
                            <div v-for="option in listflaw" :key="option" class="d-inline-block mx-4">
                              <input type="checkbox" v-model="option.chk" :check="option.chk" /><label
                                class="flex-auto form-label ms-2">
                                {{ option.name }}</label>
                            </div>
                          </div>

                        </Panel>
                      </div>
                      <material-input v-model="collect_detail.remark" autocomplete="off" class="w-100" />
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="modal-footer justify-content-between">
                <div>
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal" id="newPawnClose">
                    {{ cancel }}
                  </button>
                </div>


                <button id="updateColl" type="button" class="btn btn-primary" data-bs-dismiss="modal" :disabled="(collect_detail.mainCatUid === '' || collect_detail.mainCatUid === '0') || (collect_detail.quantity === null  || collect_detail.quantity === '' || collect_detail.quantity === 0) || (collect_detail.pawnValue === null || collect_detail.pawnValue === '' || collect_detail.pawnValue === '0')
                  || (collect_detail.weight === null || collect_detail.weight === '' || collect_detail.weight === '0') || filterText === '' || collect_detail.unitUid === '0'
                  || collect_detail.remark.trim() === ''"
                  @click="checkProcess">
                  {{ $t("buttons.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>


        <!-- Add File Dialog -->
        <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="unseizeModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 800px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ cus_detail.nameTh }}
                  ({{ $t("content.ticketno") }} : <span
                    v-if="String(tk_detail.tkRefNumber) !== '' && tk_detail.tkRefNumber !== null">
                    {{String(tk_detail.tkRefNumber) }}
                  </span><span v-else>-</span>)
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <fieldset>
                  <div class="row">
                    <div class="col-lg-12">
                      {{ $t("content.previmg") }} : {{ images.length }}
                    </div>
                  </div>
                  <pre></pre>
                  <div class="grid-containerP" v-if="images.length">
                    <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                      <td>
                        <div class="wrapper">
                          <figure width="100px" height="100px">
                            <img :src="item.src" class="img img-fluid" />
                          </figure>
                        </div>
                      </td>
                    </div>
                  </div>
                </fieldset>
                <hr />
                <pre></pre>
                <fieldset>
                  <div class="row">
                    <div class="col-lg-12">
                      <!-- 1. ซ่อนอินพุตดั้งเดิมไว้ และใช้ไอดี 'upload' เชื่อมโยงแทน -->
                      <input id="upload" type="file" accept="image/*" @change="addFile" class="d-none" />
                      
                      <!-- 2. ดีไซน์ปุ่มอัปโหลดใหม่ให้โมเดิร์น มีไอคอนนำสายตา -->
                      <div class="d-flex flex-column gap-2">
                        <label for="upload" class="btn btn-outline-secondary d-inline-flex align-items-center justify-content-center p-3 border-dashed bg-light w-100 cursor-pointer text-muted rounded-3" style="border: 2px dashed #dee2e6;">
                          <i class="fa fa-cloud-upload-alt me-2 fs-5"></i>
                          <span>{{ file_d ? file_d.name : 'คลิกเพื่อเลือกรูปภาพหรือไฟล์แนบ' }}</span>
                        </label>

                        <!-- 3. ข้อความแจ้งเตือนที่จัดขยับเข้าในให้ดูบาลานซ์และสมส่วน -->
                        <div v-if="file_error_msg" class="d-flex align-items-center text-danger px-1 mt-2">
                          <small class="fw-semibold d-flex align-items-center">
                            <!-- 🟢 เปลี่ยนจาก me-1.5 เป็น me-2 เพื่อเพิ่มระยะห่างระหว่างไอคอนกับตัวหนังสือ -->
                            <i class="fa fa-exclamation-circle me-2 fs-6"></i>
                            {{ file_error_msg }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                <!-- 4. ส่วนพรีวิวรูปภาพเมื่อเลือกไฟล์สำเร็จ (ปรับมาเช็คค่าจากตัวแปร thumb แทน) -->
                  <div class="row mt-3" v-if="thumb">
                    <div class="col-lg-12">
                      <div class="bank-logo d-flex align-items-center justify-content-center p-2 border rounded bg-light">
                        <!-- 🟢 เปลี่ยนจาก :src="preview" มาผูกกับ :src="thumb" แทนตามฟังก์ชัน addFile -->
                        <img :src="thumb" alt="Preview" :width="picWidth" :height="picHeight" style="object-fit: contain; max-width: 100%;" class="rounded img-fluid" />
                      </div>
                    </div>
                  </div>
                </fieldset>

              </div>

              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="thumb = null">
                  {{ cancel }}
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                  {{ save }}
                </button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import Textarea from 'primevue/textarea';
import InputMask from 'primevue/inputmask';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import Panel from 'primevue/panel';
import { reactive, inject, computed, onMounted, ref, onUpdated, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import NewCamera from "../../examples/WebCam/NewCamera.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import ExampleFive from "@/examples/ExampleOne";

import moment from 'moment'
import noImg from "@/assets/img/noimg.png"

import { useCategoryStore } from '@/stores/category'
import { useUniteStore } from '@/stores/unit'
import { useDocumentStore } from '@/stores/document'
import { useFlawtStore } from '@/stores/flaw'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useDocTypeStore } from '@/stores/doctype'
import { useCusTypeStore } from '@/stores/custype'
import { useCountryStore } from '@/stores/country'
import { useDistrictStore } from '@/stores/district'
import { useSubdistrictStore } from '@/stores/subdistrict'
import { useProvinceStore } from '@/stores/province'
import { useCustomerStore } from '@/stores/customer'
import { useCusShopStore } from '@/stores/cusshop'
import { useMigrationTkStore } from '@/stores/migrationtk'




const storec = useCategoryStore()
const storeu = useUniteStore()
const storedoc = useDocumentStore()
const storetf = useFlawtStore()
const storeca = useCashAccountStore()
const storedt = useDocTypeStore()
const storect = useCusTypeStore()
const storecountry = useCountryStore()
const storedistrict = useDistrictStore()
const storesd = useSubdistrictStore()
const storep = useProvinceStore()
const storecus = useCustomerStore()
const storecussh = useCusShopStore()
const storemgt = useMigrationTkStore()

const { t } = useI18n();
const swal = inject("$swal");

const search = computed(() => t("buttons.sear"));
const cancel = computed(() => t("buttons.canc"));
const save = computed(() => t("buttons.save"));

const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const time = ref(false);
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_search = ref('');
const listdata = ref([]);
const shop_detail = ref(null)


const cusUidd_search = ref('');
const cusNamed_search = ref('');
const cus_search = ref('');

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')
const customerlist = ref([]);

const images = ref([])
const images_l = ref([])
const loading_d = ref(false);
const listprint = ref([]);
const listQ02D = ref([]);
const listunit = ref([]);
const listflaw = ref([]);
const photoFile = ref([]);


const balprice = ref(0);
const balfull = ref(0);
const balquanity = ref(0);


// infinite scroll
var input = (ref < HTMLInputElement) | (null > null);
const loadMoreStatus = ref("idle");
const parentRef = ref(null);
const list = ref(null);

const dataList = ref([]);
const loading = ref(false);
const showSuggestions = ref(false);
const limit = 10;
const page_s = ref(0);
const page_e = ref(10);
const filterText = ref("");
const filterInput = ref("");
const typesNew = ref([]);
const selected = ref("");
const textt = ref("");
const Listdata = ref([]);
const types = ref([]);
const tplist = ref([]);

const parentWidth = ref(0);
const childWidth = ref(0);

const openFlaw = ref(false);
const regex = /data:.*base64,/
const mimeType = ref("");
const thumb_name = ref('');
const count_success = ref(0);
const err_msg = ref("");

const custypeList = ref([])
const doctypeAccList = ref([])
const listCountry = ref([]);
const listProvince = ref([]);
const listDistrict = ref([]);
const listSubDistrict = ref([]);
const collIndex = ref(0);
const cansave = ref(false);

const thumb_id = ref("0");
const thumb = ref(null);
const preview = ref("");
const listimg = ref([]);
const thumb_att = ref(null);
const file_d = ref(null);
const file_error_msg = ref("");

const hideCam = ref(false);
const picWidth = ref(400);
const picHeight = ref(300);

const datas = reactive({
  hide: false,
  scanStep: false,
});



const collect_detail = ref({
  uid: '',
  ticketUid: '',
  mainCatUid: '0',
  mainCatCode: '',
  mainCatName: '',
  categoryUid: '',
  categoryCode: '',
  categoryName: '',
  weight: '',
  pawnValue: '',
  newPawnValue: '',
  tmpPawnValue: '',
  tmpNewPawnValue: '',
  fullValue: '',
  diamondQuantity: '',
  quantity: '',
  unitUid: '0',
  unitName: '',
  remark: '',
  collateralGroupUid: '',
  version: '',
  serialNumber: '',
});

const cus_detail = ref({
  uid: '',
  nameTh: '',
  nameEn: '',
  birthOrRegDate: new Date(),
  address: {
    address1: "",
    subDistrict: "",
    district: "",
    province: "",
    postcode: "",
    country: ""
  },
  issuedBy: '',
  issuedDate: new Date(),
  expiredDate: new Date(),
  version: '',
  age: 0,
  docTypeUid: '0',
  docNumber: '',
  lifetime: false,
  cusShop: {
    cusTypeUid: "0",
    creditAmount: 0,
    email: "",
    phoneNo1: "",
    phoneNo2: "",
    phoneNo3: "",
    fingerPrint1Uid: "0",
    fingerPrint2Uid: "0",
    fgTemplate1Uid: "0",
    fgTemplate2Uid: "0",
    warningMsg: "",
    notifyWarning: false,
  }
})


const tk_detail = ref({
    uid: "",
    tkVolNo: "",
    tkNo: "",
    txType: "", // PAWN, INTEREST, DEC_PRINCIPLE, INC_PRINCIPLE
    tkRefNumber: "",
    pawnDate:  new Date(new Date().setHours(0, 0, 0)),
    pawnValue:  "",
    fullValue:  "",
    interest:  "",
    dueDate: new Date(),
    quantity: "",
    prevTkVolNo: "",
    prevTkNo: "",
    tkCusUid: "",
    version: "",
    collaterals: [],
    images:[],
})

const toggleInfo = () => {
  if (!datas.hide) {
    datas.hide = true;
  } else {
    datas.hide = false;
  }
};

const tx_list = ref([
  { name: t("content.actpawn1"), code: 'PAWN' },
  { name: t("content.actpawn2"), code: 'INTEREST' },
  { name: t("content.actpawn3"), code: 'INC_PRINCIPLE' },
  { name: t("content.actpawn4"), code: 'DEC_PRINCIPLE' },
]);


const openCamera = () => {
  hideCam.value = true;
};

const format = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
    format: 'dd/MM/yyyy HH:mm'
}

const formatpd = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm:ss');
}
  

const textInputOptionspd = {
    format: 'dd/MM/yyyy HH:mm:ss'
};


const formatd = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptionsd = {
  format: 'dd/MM/yyyy'
}

const formatDateTimeToBE = (date) => {
  date = new Date(date);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const yearBE = date.getFullYear() + 543;
  return `${day}/${month}/${yearBE}`+' '+moment(String(date)).local().format('HH:mm:ss');;
};

const formatDateToBE = (date) => {
  date = new Date(date);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const yearBE = date.getFullYear() + 543;
  return `${day}/${month}/${yearBE}`;
};


const onClickHandler = () => {
    updatePagination()
};

const onClickHandlerC = () => {
  updatePaginationC()
};


const onserachDate = () => {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
};

const savephotoTaken = async (data) => {
  hideCam.value = false;
  photoFile.value = data
  calItems()
}


const closeCamera = (data) => {
  hideCam.value = false;
  localStorage.removeItem("dataL");
  localStorage.removeItem("imageL");
  calItems()
};




// Fetch data function
const fetchData = async () => {
  try {
    loading.value = true;
    await new Promise(res => setTimeout(res, 500));
    // console.log('typesNew fetch : ' + JSON.stringify(typesNew.value))
    const res = typesNew.value.slice(page_s.value, page_e.value);
    // console.log('res fetch : ' + JSON.stringify(res))
    dataList.value.push(...res);
    loadMoreStatus.value = res.length < limit ? "no-more" : "idle";
    page_s.value = page_s.value + res.length;
    page_e.value = page_s.value + limit;
    showSuggestions.value = true;

  } catch (error) {
    console.error('Error fetching data:', error);
    loading.value = false;
  } finally {
    loading.value = false;
  }
};

// Handle scroll event for infinite loading
const handleScroll = () => {
  const scrollContainer = list.value;
  // console.error('scrollTop :', scrollContainer.scrollTop);
  // console.error('clientHeight :', scrollContainer.clientHeight);
  // console.error('scrollHeight :', scrollContainer.scrollHeight);
  if (scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight) {
    // Reached the bottom of the scroll container, load more data
    if (dataList.value.length <= 10) {
      // console.log("data : " + dataList.value.length);
      scrollContainer.scrollTo(0, 0);
    }

    if (typesNew.value.length > 0) {
      fetchData();
    }

  }
};


// Function to update widths
const updateWidths = () => {
  if (parentRef.value && list.value) {
    parentWidth.value = parentRef.value.clientWidth;
    childWidth.value = parentRef.value.clientWidth;
  }
}
/* eslint-disable no-useless-escape */
const updateText = () => {
  let inp = document.querySelector("#inp");
  let list = document.querySelectorAll('#myList li')
  // console.log("updated() list : " + list.length);
  var filtter = inp.value.trim().replaceAll(">>", " ");
  var text = filtter.toLowerCase().replaceAll("'", " ");
  var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_-]+/g;
  var repl = text.replace(invalid, "")
  var arrt = repl.match(/\S+/g);

  if (arrt !== null) {
    const arr = Array.from(list);
    arr.forEach((x) => {
      // if (re.test(x.textContent)) {
      const txtValue = x.innerText || x.textContent;
      var string = txtValue;

      var finalAns = string;
      for (var i = arrt.length - 1; i >= 0; i--) {
        finalAns = finalAns.replace(
          RegExp(arrt[i], "gi"),
          '<b style="color:orange;">$&</b>'
        );
      }
      x.innerHTML = finalAns;
      x.style.display = "block";
    });
  }
}


const selectFlaw = () => {
  // console.log('listflaw : ' + JSON.stringify(listflaw.value))
  // console.log('selectFlaw')
  if (listflaw.value.length > 0) {
    if (openFlaw.value) {
      openFlaw.value = false
      if (listflaw.value.length > 0) {
        for (let i = 0; i < listflaw.value.length; i++) {
          listflaw.value[i].chk = false
        }
      }
    } else {
      openFlaw.value = true
    }
    // document.getElementById("defectsBtn").click();
    // console.log('listflaw : ' + JSON.stringify(listflaw.value))

  }
}

const flawSelection = () => {
  let fdt = ''
  if (listflaw.value.length > 0) {
    for (let i = 0; i < listflaw.value.length; i++) {
      if (listflaw.value[i].chk) {
        // console.log('flawSelection : ' + JSON.stringify(listflaw.value[i]))
        if (fdt === '') {
          fdt = listflaw.value[i].name
        } else {
          fdt = fdt + ' ' + listflaw.value[i].name
        }
      }
    }
    setRematkDetail()
    if (fdt !== '') {

      if (collect_detail.value.remark !== '') {
        collect_detail.value.remark = collect_detail.value.remark + ' ' + fdt
      } else {
        collect_detail.value.remark = fdt
      }

      if (collect_detail.value.serialNumber !== '') {
        setSerialDetail()
      }
    }
    selectFlaw()
  }

}


const setRemark = () => {
  setRematkDetail()
  if (collect_detail.value.serialNumber !== '') {
    setSerialDetail()
  }
}


const setRematkDetail = () => {
  let dt = ''
  // console.log("mainCatUid : " + collect_detail.value.mainCatUid);
  if (collect_detail.value.mainCatUid !== '0') {
    let ld = listprint.value.filter((c) => c.uid === collect_detail.value.mainCatUid);
    // console.log("ld : " + ld.length);
    if (ld.length > 0) {
      // let ld = listprint.value.filter((c) => c.name.toLowerCase().indexOf(selected.value.t1.toLowerCase()) >= 0);
      if (ld[0].name !== 'อื่นๆ') {
        if (selected.value === '') {
          let sl = types.value.filter((c) => c.fullName.toLowerCase().indexOf(filterText.value.trim().toLowerCase()) >= 0);
          if (sl.length > 0) {
            selected.value = sl[0]
          }
        }
        // console.log("ld : " + JSON.stringify(ld[0]));
        if (selected.value !== '') {
          if (ld[0].l2Print) {
            if (selected.value.t2 !== '') {
              dt = selected.value.t2
            }

          }
          if (ld[0].l3Print) {
            if (selected.value.t3 !== '') {
              if (dt === '') {
                dt = selected.value.t3
              } else {
                dt = dt + ' ' + selected.value.t3
              }
            }

          }
          if (ld[0].l4Print) {
            if (selected.value.t4 !== '') {
              if (dt === '') {
                dt = selected.value.t4
              } else {
                dt = dt + ' ' + selected.value.t4
              }
            }

          }
          if (ld[0].l5Print) {
            if (selected.value.t5 !== '') {
              if (dt === '') {
                dt = selected.value.t5
              } else {
                dt = dt + ' ' + selected.value.t5
              }
            }

          }
          if (ld[0].l6Print) {
            if (selected.value.t6 !== '') {
              if (dt === '') {
                dt = selected.value.t6
              } else {
                dt = dt + ' ' + selected.value.t6
              }
            }
          }
        }

      } else {
        dt = filterText.value.trim()
      }
    }
    // console.log("ld : " + JSON.stringify(ld));
  }



  if (collect_detail.value.quantity !== '0' && collect_detail.value.quantity !== '' && parseFloat(collect_detail.value.quantity) > 0) {
    if (dt === '') {
      dt = collect_detail.value.quantity
    } else {
      dt = dt + ' ' + collect_detail.value.quantity
    }

    if (collect_detail.value.unitUid !== '' && collect_detail.value.unitUid !== '0') {

      if (dt === '') {
        dt = filterUnit(collect_detail.value.unitUid)
      } else {
        dt = dt + ' ' + filterUnit(collect_detail.value.unitUid)
      }
    }
  }
  if (collect_detail.value.weight !== '' && collect_detail.value.weight !== '0' && parseFloat(collect_detail.value.weight) > 0) {
    let weight = collect_detail.value.weight
    if (dt === '') {
      dt = '(' + formatNumberDecimalString(Number(weight)) + ' กรัม)'
    } else {
      dt = dt + ' (' + formatNumberDecimalString(Number(weight)) + ' กรัม)'
    }
  }

  collect_detail.value.remark = dt
}

const setSerialDetail = () => {
  if (collect_detail.value.remark === '') {
    collect_detail.value.remark = '(' + collect_detail.value.serialNumber.trim() + ')'
  } else {
    collect_detail.value.remark = collect_detail.value.remark + ' (' + collect_detail.value.serialNumber.trim() + ')'
  }
}


const addMonths = async () => {
  const newDate = new Date(tk_detail.value.pawnDate); // Create a copy to avoid mutating the original date
  newDate.setMonth(newDate.getMonth() + 4);
  tk_detail.value.dueDate = newDate;
}

addMonths()

const cashAccShopApi = async (val) => {
  shop_detail.value = null
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log("shop_detail : " + JSON.stringify(response.data.data));
        shop_detail.value = response.data.data
        loadCusTypeListApi()
        loadDocTypeAccListApi()
        if (Listdata.value.length === 0) {
          loadDataApi();
        }
    
        if (listprint.value.length === 0) {
          loadDataPrintApi()
        }
    
        if (listunit.value.length === 0) {
          loadDataUnitApi()
        }
    
        if (listCountry.value.length === 0) {
          loadCountryListApi()
        }
    
        if (listProvince.value.length === 0) {
          loadProvinceListApi()
        }
      }
    }
  }
}

cashAccShopApi()

const loadCusTypeListApi = async (val) => {
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storect.custypeListFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        custypeList.value = response.data.data.list;
      }
    }
  }
}


const loadDataPrintApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        // console.log('Listdata : ' + JSON.stringify(listprint.value))
      }
    }
  }
}


const loadDataUnitApi = async (val) => {

  let data = "";
  data = {
    index: 0,
    size: 100,
    name: '',
  };
  const payload = data;
  // const response = await store.dispatch("unitListFetch", payload);
  const response = await storeu.unitListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listunit.value = response.data.data.list;
      }
    }
  }
}


const loadCountryListApi = async (val) => {

  let data = "";
  data = {
    uid: 0,
  };

  const payload = data;
  const response = await storecountry.countryListAllFetch(payload);
  // console.log("loadCountryListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listCountry.value = response.data.data.list
        // console.log("listCountry : " + listCountry.value.length)
      }
    }
  }

}

const loadProvinceListApi = async (val) => {

  let data = "";
  data = {
    index: 0,
    size: 100,
    nameTh: '',
    nameEn: ''
  };

  const payload = data;
  const response = await storep.provinceListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listProvince.value = response.data.data.list;
      }
    }
  }
}


const loadDocTypeAccListApi = async (val) => {
  // dev : 601433176200681039 , uat : 635673099141979585 , prod : 635691584740292063
  doctypeAccList.value = []
  let data = '';
  data = {
    index: 0,
    size: 100,
    name: "",
    docGroupCode: '001'
  };

  const payload = data;
  const response = await storedt.docTypeListFetch(payload);
  // console.log("loadDocTypeListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          doctypeAccList.value = response.data.data.list;
          // console.log('list : '+list.value.length)
        }
      }
    }
  }
}


const loadAssetList = async (uid) => {
  tplist.value = []
  let data = "";
  data = {
    index: 0,
    size: 100,
    uid: uid,
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storec.categoryListFetch(payload);
  // console.log("response : " + JSON.stringify(response.data.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        tplist.value = response.data.data.list
      }
    }
  }
}

const loadDataApi = async () => {
  let data = "";
  data = {
    uid: 0,
  };
  const payload = data;

  const response = await storec.categoryfullNameFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        Listdata.value = response.data.data.list;
        // console.log('Listdata : '+JSON.stringify(response.data.data.list))
        if (Listdata.value.length > 0) {
          // console.log('newData : '+JSON.stringify(Listdata.value.length))
          types.value = [];
          checkdataMatch2(Listdata.value);
        }
      }
    }
  }
}

async function checkdataMatch2(list) {
  let list2 = [];
  let t1 = "";
  let t2 = "";
  let t3 = "";
  let t4 = "";
  let t5 = "";
  let t6 = "";


  for (let i = 0; i < list.length; i++) {
    t1 = "";
    t2 = "";
    t3 = "";
    t4 = "";
    t5 = "";
    t6 = "";

    let text = list[i].fullName;
    text = text.split(">>");
    let count = text.length - 1;
    let newText = ''
    // console.log('text sett : '+text)

    if (count > 0) {
      if (count === 1) {
        t1 = text[0];
        t2 = text[1];
        // ss = text[1] +" >> " +text[2]
        newText = text[1]
      } else if (count === 2) {
        t1 = text[0];
        t2 = text[1];
        t3 = text[2];
        // ss = text[1] +" >> " +text[2] +" >> " +text[3]
        // ss = ss +" >> " +text[2]
        newText = text[1] + '>>' + text[2]
      } else if (count === 3) {
        t1 = text[0];
        t2 = text[1];
        t3 = text[2];
        t4 = text[3];


        newText = text[1] + '>>' + text[2] + '>>' + text[3]

        // ss = text[1] +" >> " +text[2] +" >> " +text[3] +" >> " +text[4]
      } else if (count === 4) {
        t1 = text[0];
        t2 = text[1];
        t3 = text[2];
        t4 = text[3];
        t5 = text[4];

        newText = text[1] + '>>' + text[2] + '>>' + text[3] + '>>' + text[4]

        // ss = text[1] +" >> " +text[2] +" >> " +text[3] +" >> " +text[4] +" >> " +text[5]
      } else if (count === 5) {
        // console.log('data sett : '+list[i].fullName)
        t1 = text[0]
        t2 = text[1]
        t3 = text[2]
        t4 = text[3]
        t5 = text[4]
        t6 = text[5]

        newText = text[1] + '>>' + text[2] + '>>' + text[3] + '>>' + text[4] + '>>' + text[5]

      }
    }
    // console.log('data sett : '+list[i].fullName.replaceAll (">>", " "))

    const obj = {
      uid: list[i].uid,
      code: list[i].code,
      // detailt: list[i].fullName.replaceAll(">>", " "),
      // fullName: list[i].fullName,
      // datailt: list[i].fullName,
      detailt: newText.replaceAll(">>", " "),
      fullName: newText,
      datailt: newText,
      t1: t1,
      t2: t2,
      t3: t3,
      t4: t4,
      t5: t5,
      t6: t6,
    };
    list2.push(obj);
  }

  // console.log('data sett : '+JSON.stringify(list2))
  textt.value = "";
  if (list2.length > 0) {
    types.value = list2;
  }
}


async function selection(value) {
  selected.value = value;
  filterText.value = value.datailt;
  typesNew.value = [];
  textt.value = "";
  loadMoreStatus.value = "idle";
  dataList.value = [];
  // console.log('input : ' + JSON.stringify(selected.value))
  let ld = listprint.value.filter((c) => c.name.toLowerCase().indexOf(selected.value.t1.toLowerCase()) >= 0);
  if (ld.length > 0) {
    collect_detail.value.mainCatUid = ld[0].uid
    await getFlaw(ld[0].uid)
  } else {
    collect_detail.value.mainCatUid = '0'
  }
  setRemark()
}

async function newformatinput() {
  filterInput.value = "";
  page_s.value = 0;
  page_e.value = 20;
  typesNew.value = [];
  loadMoreStatus.value = "idle";
  dataList.value = [];
  collect_detail.value.mainCatUid = '0'
  listflaw.value = []
  openFlaw.value = false
  let list = []
  if (filterText.value.trim().length > 0) {
    if (filterText.value.includes(">>")) {
      let text = filterText.value.replaceAll(/\s/g, "");
      text = text.split(">>");
      let count = text.length - 1;
      if (count > 0) {
        if (count === 1) {
          // console.log('2 text[0]  : '+text[0] + ' text[1]  : '+text[1] + ' text[2]  : '+text[2])
          // console.log('count 2')
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3
                .replaceAll(/\s/g, "")
                .toLowerCase()
                .includes(text[1].toLowerCase())
          );
          // this.typesNew = list
          checkdataMatch(list);

          // console.log('2 text : '+text + 'text L : '+text.length + ' count : '+count + ' typesNew L : '+JSON.stringify(this.typesNew))
        } else if (count === 2) {
          // console.log('count 1')
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3.toLowerCase().replaceAll(/\s/g, "") ===
              text[1].toLowerCase() &&
              c.t4
                .toLowerCase()
                .replaceAll(/\s/g, "")
                .includes(text[2].toLowerCase())
          );
          // this.typesNew = list
          checkdataMatch(list);

          // console.log('1 text : '+text + 'text L : '+text.length + ' count : '+count + ' typesNew L : '+JSON.stringify(this.typesNew))
        } else if (count === 3) {
          // console.log('2 text[0]  : '+text[0] + ' text[1]  : '+text[1] + ' text[2]  : '+text[2])
          // console.log('count 2')
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3.toLowerCase().replaceAll(/\s/g, "") ===
              text[1].toLowerCase() &&
              c.t4.toLowerCase().replaceAll(/\s/g, "") ===
              text[2].toLowerCase() &&
              c.t5
                .replaceAll(/\s/g, "")
                .toLowerCase()
                .includes(text[3].toLowerCase())
          );
          // this.typesNew = list
          checkdataMatch(list);

          // console.log('2 text : '+text + 'text L : '+text.length + ' count : '+count + ' typesNew L : '+JSON.stringify(this.typesNew))
        } else if (count === 4) {
          // console.log('count 3')
          list = types.value.filter(
            (c) =>
              c.t2.toLowerCase().replaceAll(/\s/g, "") ===
              text[0].toLowerCase() &&
              c.t3.toLowerCase().replaceAll(/\s/g, "") ===
              text[1].toLowerCase() &&
              c.t4.toLowerCase().replaceAll(/\s/g, "") ===
              text[2].toLowerCase() &&
              c.t5.toLowerCase().replaceAll(/\s/g, "") ===
              text[3].toLowerCase() &&
              c.t6.toLowerCase().includes(text[4].toLowerCase())
          );
          // this.typesNew =  list
          checkdataMatch(list);

          // console.log('3 text : '+text + 'text L : '+text.length + ' count : '+count + ' typesNew L : '+JSON.stringify(this.typesNew))
        }
      } else {
        filterInput.value = filterText.value.replaceAll(">>", "");
        list = types.value.filter(
          (c) =>
            c.t2.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t3.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t4.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t5.toLowerCase().includes(filterInput.value.toLowerCase()) ||
            c.t6.toLowerCase().includes(filterInput.value.toLowerCase())
        );
        checkdataMatch(list);

        // console.log('4 text : '+text + 'text L : '+text.length + ' count : '+count + ' typesNew L : '+JSON.stringify(this.typesNew))
      }

    } else {
      if (
        filterText.value !== "" &&
        filterText.value !== undefined &&
        filterText.value !== null
      ) {
        // console.log('ft : '+this.filterText)

        filterInput.value = filterText.value.replaceAll(">>", "");
        // let stringArray = []
        // stringArray = this.filterInput.trim().toLowerCase().match(/\S+/g)
        var text = filterInput.value.trim().toLowerCase();
        var arr = text.match(/\S+/g);

        if (arr !== null) {
          // console.log('ft : ' + arr)
          list = types.value.filter((c) =>
            allAvailable(c.detailt.toLowerCase(), arr)
          );

          checkdataMatch(list);
        }
      }
    } if (list.length === 0) {
      let ld = listprint.value.filter((c) => c.name.toLowerCase().indexOf('อื่นๆ') >= 0);
      if (ld.length > 0) {
        collect_detail.value.mainCatUid = ld[0].uid
        selected.value = ''
        await getFlaw(ld[0].uid)
        setRemark()
      }
    }

  } else {
    typesNew.value = [];
    textt.value = "";
    setRemark()
  }

}


async function getFlaw(uid) {
  listflaw.value = []
  let data = "";
  data = {
    categoryUid: uid,
  };
  const payload = data;
  const response = await storetf.flawListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('getFlaw : ' + JSON.stringify(response.data));
        let list = response.data.data.list;
        list.map(function (x) {
          x.chk = false
          return x
        });
        listflaw.value = list

      }
    }
  }
}


function allAvailable(str, matchArr) {
  // console.log('str : '+str + ' / matchArr : ' +matchArr)
  return matchArr.every((item) => str.includes(item));
}



async function checkdataMatch(list) {
  let list2 = [];
  for (let i = 0; i < list.length; i++) {
    const obj = {
      datailt: list[i].datailt,
      t1: list[i].t1,
      t2: list[i].t2,
      t3: list[i].t3,
      t4: list[i].t4,
      t5: list[i].t5,
      t6: list[i].t6,
      detailt: list[i].detailt,
      fullName: list[i].fullName,
      uid: list[i].uid,
      code: list[i].code
    };
    list2.push(obj);
  }

  textt.value = "";
  if (list2.length > 0) {
    // console.log('list2 : '+list2.length)
    typesNew.value = list2;
    textt.value = "result : " + formatNumberString(list2.length) + " / " + formatNumberString(types.value.length);
    // console.log("textt : " + textt.value);
    fetchData()
    // loadData();
  }
}

function cancelBtn() {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
    cusUid_search.value = '';
    cusName_search.value = '';
    tk_search.value = '';
    listdata.value = []
    totalRows_s.value = ''
    currentPage.value = 1
    time.value = false;
}

async function onClickTab(val) {
    if (val === '1') {
        await setfirstTab()
    } else if (val === '2') {
        await setsecondTab()
    } 
}

function formatNumberString(num) {
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function formatNumberDecimalString(num) {
    if (num !== null && num !== undefined) {
        num = num.toFixed(2)
    } else {
        num = 0
        num = num.toFixed(2)
    }
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function format_datetime(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
    }
}

function format_date(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY')
    }
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  } else if (str === 'REVIEW_COLLATERAL') {
    side = 'ขอดูทรัพย์'
  }
  return side
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}

function filterMainCat(str) {
  let name = listprint.value.filter((c) => c.uid === str);
  return name[0];
}

function filterUnit(str) {
  let name = listunit.value.filter((c) => c.uid === str);
  return name[0].name;
}

async function inputBirthday() {
  cus_detail.value.age = calculateAge(new Date(cus_detail.value.birthOrRegDate));
}


function calculateAge(birthday) { // birthday is a date
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}


async function addFile(e) {
  thumb.value = null
  thumb_name.value = ""
  mimeType.value = ""
  
  file_d.value = null;
  thumb_id.value = ""; 
  file_error_msg.value = ""; // 🟢 เคลียร์ข้อความแจ้งเตือนขนาดไฟล์ทุกครั้งที่เริ่มเลือกไฟล์ใหม่

  if (e.target.files && e.target.files[0] !== undefined) {
    const originalFile = e.target.files[0];
    const maxSize = 10 * 1024 * 1024; // 10 MB

    // 1. เช็คขนาดไฟล์
    if (originalFile.size > maxSize) {
      // 🟢 เปลี่ยนจาก swal มาบันทึกข้อความลงตัวแปรแทน
      file_error_msg.value = "ขนาดไฟล์เกิน 10 MB กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 10 MB";
      e.target.value = null; // ล้างไฟล์ออกจากอินพุต
      return;
    }

    // 2. ตั้งชื่อไฟล์และตรวจสอบ MimeType
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let baseName = 'file_' + today

    if (originalFile.type === "image/jpeg") {
      thumb_name.value = baseName + ".jpg"
      mimeType.value = "image/jpeg"
    } else if (originalFile.type === "image/png") {
      thumb_name.value = baseName + ".png"
      mimeType.value = "image/png"
    } else if (originalFile.type === 'application/pdf') {
      thumb_name.value = baseName + ".pdf"
      mimeType.value = "application/pdf"
    } else if (originalFile.type.includes('excel') || originalFile.type.includes('spreadsheetml') || originalFile.name.toLowerCase().endsWith('.xlsx') || originalFile.name.toLowerCase().endsWith('.xls')) {
      thumb_name.value = baseName + ".xlsx"
      mimeType.value = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    } else {
      thumb_name.value = baseName + "_" + originalFile.name
      mimeType.value = originalFile.type
    }

    // 3. เปลี่ยนชื่อไฟล์จริงในโค้ด JavaScript ด้วยโครงสร้าง New File
    const renamedFile = new File([originalFile], thumb_name.value, {
      type: originalFile.type,
      lastModified: originalFile.lastModified
    });

    // บันทึกก้อนไฟล์ดิบที่เปลี่ยนชื่อสำเร็จแล้วไว้ส่ง API
    file_d.value = renamedFile;

    // บันทึก URL พรีวิวภาพลงใน thumb.value เพื่อพรีวิวในแท็ก <img> หน้าเว็บ
    thumb.value = URL.createObjectURL(renamedFile);
  }
}



async function saveFile() {
   thumb.value = thumb_att.value
}



async function loadListApi() { 
    if (cusUid_search.value !== '' || tk_search.value !== ''|| time.value) {
        currentPage.value = 1
    }

    let data = "";
    let sd = ''
    let ed = ''
    if (time.value) {
        sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
        ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
    }

    data = {
        index: currentPage.value - 1,
        size: perPage.value,
        fromDate: sd,
        toDate: ed,
        tkRefNumber: tk_search.value.trim(),
        tkCusUid: cusUid_search.value,
    };
    const payload = data;
    // console.log("lh p : " + JSON.stringify(payload));
    const response = await storemgt.mgtListFetch(payload);
    // console.log("ldt r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listdata.value = response.data.data.list
                totalRows.value = response.data.data.ext.total
                totalRows_s.value = formatNumberString(totalRows.value)
            }
        }
    }
}

async function setfirstTab() {
    if (document.getElementById("tab2-tab")) {
        document.getElementById("tab2-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab2")) {
        document.getElementById("tab2").classList.remove('show', 'active')
    }

    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.add('show', 'active')
    }
}

async function setsecondTab() {

    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.remove('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.remove('show', 'active')
    }


    if (document.getElementById("tab2-tab")) {
        document.getElementById("tab2-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab2")) {
        document.getElementById("tab2").classList.add('show', 'active')
    }

}

async function openDialogCusS() {
    cus_search.value = 'S'
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUid_search.value = ''
    cusName_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}

async function openDialogCusD() {
    cus_search.value = 'D'
    nameThC.value = ''
    nameEnC.value = ''
    docNumberC.value = ''
    cusUidd_search.value = ''
    cusNamed_search.value = ''
    customerlist.value = []
    document.getElementById("searchNameCus").click();
}


async function selectCus(item) {
    if (cus_search.value === 'S') {
        cusUid_search.value = item.uid
        cusName_search.value = item.nameTh
    } else if (cus_search.value === 'D') {
        cusUidd_search.value = item.uid
        cusNamed_search.value = item.nameTh
        await setCustomerInfo()    }
    document.getElementById("closeModal").click();
}


async function setCustomerInfo() {

  await getCustomerInfo(cusUidd_search.value)

  if (cus_detail.value.birthOrRegDate === null) {
    cus_detail.value.birthOrRegDate = new Date()
  }

  if (cus_detail.value.issuedDate === null) {
    cus_detail.value.issuedDate = new Date()
  }

  if (cus_detail.value.expiredDate === null) {
    cus_detail.value.expiredDate = new Date()
  }

  if (cus_detail.value.issuedBy === null) {
    cus_detail.value.issuedBy = ""
  }

  if (cus_detail.value.docTypeUid !== '0') {
    let dn = doctypeAccList.value.filter((c) => c.uid === cus_detail.value.docTypeUid)
    if (dn.length === 0) {
      cus_detail.value.docTypeUid = '0'
    }
  }

  inputBirthday()

  if (cus_detail.value.address !== null) {

    if (cus_detail.value.address.country === null) {
      cus_detail.value.address.country = ''
    }

    if (cus_detail.value.address.country === '') {
      if (cus_detail.value.address.province !== '' && cus_detail.value.address.province !== null) {
        cus_detail.value.address.country = 'ไทย'
      }
    }

    if (cus_detail.value.address.country === 'ไทย') {

      let object = Object.assign({}, ...filterCountry(cus_detail.value.address.country));
      cus_detail.value.address.country = object
      // console.log('country : ' + JSON.stringify(cus_detail.value.address.country));

      if (cus_detail.value.address.province !== '' && cus_detail.value.address.province !== null) {
        object = Object.assign({}, ...filterProvince(cus_detail.value.address.province.replace("จังหวัด", "")));
        cus_detail.value.address.province = object
        // console.log('province : ' + JSON.stringify(cus_detail.value.address.province));
        await loadDistrictListApi(cus_detail.value.address.province.uid)
      }

      if (cus_detail.value.address.district !== '' && cus_detail.value.address.district !== null) {
        object = Object.assign({}, ...filterDistrict(cus_detail.value.address.district));
        cus_detail.value.address.district = object
        // console.log('district : ' + JSON.stringify(cus_detail.value.address.district));
        await loadSubDistrictListApi(cus_detail.value.address.district.uid)
      }

      if (cus_detail.value.address.subDistrict !== '' && cus_detail.value.address.subDistrict !== null) {
        object = Object.assign({}, ...filterSubDistrict(cus_detail.value.address.subDistrict));
        cus_detail.value.address.subDistrict = object
        // console.log('subDistrict : ' + JSON.stringify(cus_detail.value.address.subDistrict));
      }

    } else if (cus_detail.value.address.country !== '') {
      let object = Object.assign({}, ...filterCountry(cus_detail.value.address.country));
      cus_detail.value.address.country = object
      cus_detail.value.address.province = ""
      cus_detail.value.address.district = ""
      cus_detail.value.address.subDistrict = ""
      cus_detail.value.address.postcode = ""

    } else {
      cus_detail.value.address.country = ""
      cus_detail.value.address.province = ""
      cus_detail.value.address.district = ""
      cus_detail.value.address.subDistrict = ""
      cus_detail.value.address.postcode = ""

    }

  } else {
    let obj = {
      address1: "",
      subDistrict: "",
      district: "",
      province: "",
      postcode: "",
      country: ""
    }
    cus_detail.value.address = obj
  }

}


async function updateCustomerShop(action) {
  const payload = cus_detail.value.cusShop;
  if ((payload.email !== '' && payload.email !== null) && !checkformatEmail(payload.email)) {
    swal("กรุณาตรวจสอบอีเมล", "", "error");
  } else {
    if (payload.phoneNo1 !== null) {
      payload.phoneNo1 = payload.phoneNo1.replace(/[^\d]/g, "")
    }

    if (payload.phoneNo2 !== null) {
      payload.phoneNo2 = payload.phoneNo2.replace(/[^\d]/g, "")
    }

    if (payload.phoneNo3 !== null) {
      payload.phoneNo3 = payload.phoneNo3.replace(/[^\d]/g, "")
    }
    // console.log('updatef p : ' + JSON.stringify(payload));
    const response = await storecussh.cusShopUpdateFetch(payload)
    // console.log('updatef r : ' + JSON.stringify(response.data));
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          if (action === 'data') {
            swal("บันทึกสำเร็จ", "", "success");
            cus_detail.value.cusShop = response.data.data
          } else if (action === 'finger') {
            cus_detail.value.cusShop = response.data.data
          }

        } else {
          swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
          if (response.data.rtnDesc === 'object already modified') {
          // backToSecondTab()
        }
        }
      }
    }
  }
}


function checkformatEmail(email) {
  const reg = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
  const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const validRegex2 = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (email.match(validRegex) && email.toLowerCase().match(validRegex2)) {
    return true;
  } else {
    return false;
  }
}

function filterCountry(str) {
  return listCountry.value.filter((c) => c.nameTh === str);
}

function filterProvince(str) {
  return listProvince.value.filter((c) => c.nameTh === str);
}

function filterDistrict(str) {
  return listDistrict.value.filter((c) => c.nameTh === str);
}

function filterSubDistrict(str) {
  return listSubDistrict.value.filter((c) => c.nameTh === str);
}


async function loadDistrictListApi(uid) {

  let data = "";
  data = {
    index: 0,
    size: 100,
    uid: uid,
    nameTh: '',
    nameEn: ''
  };

  const payload = data;
  const response = await storedistrict.districtListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listDistrict.value = response.data.data.list;
      }
    }
  }
}

async function loadSubDistrictListApi(uid) {

  let data = "";
  data = {
    index: 0,
    size: 100,
    uid: uid,
    nameTh: '',
    nameEn: ''
  };

  const payload = data;
  const response = await storesd.subdistrictListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listSubDistrict.value = response.data.data.list;
      }
    }
  }
}


async function updatePagination() { 
    listdata.value = []
    let data = "";
    let sd = ''
    let ed = ''
    if (time.value) {
        sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
        ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
    }

    data = {
        index: currentPage.value - 1,
        size: perPage.value,
        fromDate: sd,
        toDate: ed,
        tkRefNumber: tk_search.value.trim(),
        tkCusUid: cusUid_search.value,
    };
    const payload = data;
    // console.log("lh p : " + JSON.stringify(payload));
    const response = await storemgt.mgtListFetch(payload);
    // console.log("ldt r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                listdata.value = response.data.data.list
                totalRows.value = response.data.data.ext.total
                totalRows_s.value = formatNumberString(totalRows.value)
            }
        }
    }
}


async function loadCustomerListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,    
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePaginationC() {
    customerlist.value = []
    let data = "";
    data = {
        index: currentPageC.value - 1,
        size: perPageC.value,
        nameEn: nameEnC.value,
        nameTh: nameThC.value,
        docNumber: docNumberC.value,    
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid

    };
    const payload = data;
    // console.log("payload : " + JSON.stringify(payload));
    const response = await storecus.searchCustomerFetch(payload);
    // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                customerlist.value = response.data.data.list;
                totalRowsC.value = response.data.data.ext.total
                totalRows_sC.value = formatNumberString(totalRowsC.value)
            }
        }
    }
}

async function onlyDigits(val) { 
  if (val === 'tkVolNo') {
    if (tk_detail.value.tkVolNo !== "") {
      if (tk_detail.value.tkVolNo.match(/^[0-9]+$/)) {
        tk_detail.value.tkVolNo = tk_detail.value.tkVolNo.match(/^[0-9]+$/);
        calItems()
      } else {
        tk_detail.value.tkVolNo = tk_detail.value.tkVolNo.slice(0, -1);
      }
    } else {
      tk_detail.value.tkVolNo = "";
    }
  } else if (val === 'tkNo') {
    if (tk_detail.value.tkNo !== "") {
      if (tk_detail.value.tkNo.match(/^[0-9]+$/)) {
        tk_detail.value.tkNo = tk_detail.value.tkNo.match(/^[0-9]+$/);
        calItems()
      } else {
        tk_detail.value.tkNo = tk_detail.value.tkNo.slice(0, -1);
      }
    } else {
      tk_detail.value.tkNo = "";
    }
  } else if (val === 'tkRefNumber') {
    if (tk_detail.value.tkRefNumber !== "") {
      if (tk_detail.value.tkRefNumber.match(/^[0-9]+$/)) {
        tk_detail.value.tkRefNumber = tk_detail.value.tkRefNumber.match(/^[0-9]+$/);
        calItems()
      } else {
        tk_detail.value.tkRefNumber = tk_detail.value.tkRefNumber.slice(0, -1);
      }
    } else {
      tk_detail.value.tkRefNumber = "";
    }
  }else if(val === 'prevTkVolNo') {
    if (tk_detail.value.prevTkVolNo !== "") {
      if (tk_detail.value.prevTkVolNo.match(/^[0-9]+$/)) {
        tk_detail.value.prevTkVolNo = tk_detail.value.prevTkVolNo.match(/^[0-9]+$/);
        calItems()
      } else {
        tk_detail.value.prevTkVolNo = tk_detail.value.prevTkVolNo.slice(0, -1);
      }
    } else {
      tk_detail.value.prevTkVolNo = "";
    }
  }else if(val === 'prevTkNo') {
    if (tk_detail.value.prevTkNo !== "") {
      if (tk_detail.value.prevTkNo.match(/^[0-9]+$/)) {
        tk_detail.value.prevTkNo = tk_detail.value.prevTkNo.match(/^[0-9]+$/);
        calItems()
      } else {
        tk_detail.value.prevTkNo = tk_detail.value.prevTkNo.slice(0, -1);
      }
    } else {
      tk_detail.value.prevTkNo = "";
    }
  }
}

async function checkProcess() { 
    if (collect_detail.value.unitUid !== '' && collect_detail.value.unitUid !== '0') {
          collect_detail.value.unitName = filterUnit(collect_detail.value.unitUid)
    }
  
    if (collect_detail.value.mainCatUid !== '' && collect_detail.value.mainCatUid !== '0') {
        let ll = filterMainCat(collect_detail.value.mainCatUid)
    
        if (ll !== null) {
          collect_detail.value.mainCatCode = ll.code
          collect_detail.value.mainCatName = ll.name
        }
    }
  
    if (collect_detail.value.fullValue === '') {
      collect_detail.value.fullValue = 0
    }
  
    if (collect_detail.value.diamondQuantity === '') {
      collect_detail.value.diamondQuantity = 0
    }
  
    if (collect_detail.value.weight === '') {
      collect_detail.value.weight = 0
    }
  
    if (selected.value !== '') {
      let ld = types.value.filter((c) => c.uid.toLowerCase().indexOf(selected.value.uid.toLowerCase()) >= 0);
      if (ld.length > 0) {
        if (ld[0].name !== 'อื่นๆ') {
          collect_detail.value.categoryUid = ld[0].uid
          collect_detail.value.categoryCode = ld[0].code
          collect_detail.value.categoryName = ld[0].fullName
        } else {
          collect_detail.value.categoryUid = ''
          collect_detail.value.categoryCode = ''
          collect_detail.value.categoryName = filterText.value.trim()
        }
  
      }
    } else {
  
      if (collect_detail.value.mainCatName === 'อื่นๆ') {
        collect_detail.value.categoryUid = ''
        collect_detail.value.categoryCode = ''
        collect_detail.value.categoryName = filterText.value.trim()
        await loadAssetList(collect_detail.value.mainCatUid)
        if (tplist.value.length > 0) {
          // console.log('tplist : ' + JSON.stringify(tplist.value));
          let ld = tplist.value.filter((c) => c.name.toLowerCase().indexOf('อื่นๆ') >= 0);
          if (ld.length > 0) {
            collect_detail.value.categoryUid = ld[0].uid
            collect_detail.value.categoryCode = ld[0].code
            collect_detail.value.categoryName = filterText.value.trim()
          }
        }
      } else {
        collect_detail.value.categoryUid = ''
        collect_detail.value.categoryCode = ''
        collect_detail.value.categoryName = filterText.value.trim()
      }
    }
  
    collect_detail.value.weight = parseFloat(collect_detail.value.weight)
    collect_detail.value.pawnValue = parseFloat(collect_detail.value.pawnValue)
    collect_detail.value.newPawnValue = parseFloat(collect_detail.value.pawnValue)
    collect_detail.value.tmpPawnValue = parseFloat(collect_detail.value.pawnValue)
    collect_detail.value.tmpNewPawnValue = parseFloat(collect_detail.value.pawnValue)
    collect_detail.value.fullValue = parseFloat(collect_detail.value.fullValue)
    collect_detail.value.diamondQuantity = parseInt(collect_detail.value.diamondQuantity)
    collect_detail.value.quantity = parseInt(collect_detail.value.quantity)
  
  
    if (collect_detail.value.unitUid === '0') {
      collect_detail.value.unitUid = ''
      collect_detail.value.unitName = ''
    }
    
    if (collIndex.value === -1) {
      await addItems()
    } else if (collIndex.value !== -1) {
      await updateItems(collIndex.value)
    }
} 

async function addItems() { 
  listQ02D.value.push(
    {
      mainCatUid: collect_detail.value.mainCatUid,
      mainCatCode: collect_detail.value.mainCatCode,
      mainCatName: collect_detail.value.mainCatName,
      categoryUid: collect_detail.value.categoryUid,
      categoryCode: collect_detail.value.categoryCode,
      categoryName: collect_detail.value.categoryName,
      weight: collect_detail.value.weight,
      pawnValue:  collect_detail.value.pawnValue,
      newPawnValue: collect_detail.value.newPawnValue,
      tmpPawnValue: collect_detail.value.tmpPawnValue,
      tmpNewPawnValue: collect_detail.value.tmpNewPawnValue,
      fullValue: collect_detail.value.fullValue,
      diamondQuantity: collect_detail.value.diamondQuantity,
      quantity: collect_detail.value.quantity,
      unitUid: collect_detail.value.unitUid,
      unitName: collect_detail.value.unitName,
      serialNumber: collect_detail.value.serialNumber,
      remark: collect_detail.value.remark,
      remarkL: [{ val: collect_detail.value.remark }]
    });


    await calItems()
}


async function updateItems(index) { 
  listQ02D.value[index].mainCatUid = collect_detail.value.mainCatUid
  listQ02D.value[index].mainCatCode = collect_detail.value.mainCatCode
  listQ02D.value[index].mainCatName = collect_detail.value.mainCatName
  listQ02D.value[index].categoryUid = collect_detail.value.categoryUid
  listQ02D.value[index].categoryCode = collect_detail.value.categoryCode
  listQ02D.value[index].categoryName = collect_detail.value.categoryName
  listQ02D.value[index].weight = collect_detail.value.weight
  listQ02D.value[index].pawnValue = collect_detail.value.pawnValue
  listQ02D.value[index].newPawnValue = collect_detail.value.newPawnValue
  listQ02D.value[index].tmpPawnValue = collect_detail.value.tmpPawnValue
  listQ02D.value[index].tmpNewPawnValue = collect_detail.value.tmpNewPawnValue
  listQ02D.value[index].fullValue = collect_detail.value.fullValue
  listQ02D.value[index].diamondQuantity = collect_detail.value.diamondQuantity
  listQ02D.value[index].quantity = collect_detail.value.quantity
  listQ02D.value[index].unitUid = collect_detail.value.unitUid
  listQ02D.value[index].unitName = collect_detail.value.unitName
  listQ02D.value[index].serialNumber = collect_detail.value.serialNumber
  listQ02D.value[index].remark = collect_detail.value.remark
  listQ02D.value[index].remarkL = [{ val: collect_detail.value.remark }]
  await calItems()
}

async function deleteItems(index) { 
  listQ02D.value.splice(index, 1);
  await calItems()
}

async function calItems() { 
  if (tk_detail.value.fullValue === null || tk_detail.value.fullValue === undefined || tk_detail.value.fullValue === "") {
    balfull.value = 0
  } else {
    balfull.value = tk_detail.value.fullValue
  }

  if (tk_detail.value.quantity === null || tk_detail.value.quantity === undefined || tk_detail.value.quantity === "") {
    balquanity.value = 0
  } else {
    balquanity.value = tk_detail.value.quantity
  }

  if (tk_detail.value.pawnValue === null || tk_detail.value.pawnValue === undefined || tk_detail.value.pawnValue === "") {
    balprice.value = 0
  } else {
    balprice.value = tk_detail.value.pawnValue
  }

  if (listQ02D.value.length > 0) {
    for (let i = 0; i < listQ02D.value.length; i++) {
        balfull.value = balfull.value - listQ02D.value[i].fullValue
        balquanity.value = balquanity.value - listQ02D.value[i].quantity
        balprice.value = balprice.value - listQ02D.value[i].pawnValue
      }
  }

  // console.log('balfull : ' + balfull.value + ' / balquanity : ' + balquanity.value + ' / balprice : ' + balprice.value);
  cansaveMgt()
}


async function saveMgt() {
  // ดึงข้อมูลภาพชุดดั้งเดิมมารองรับฟลูตาราง (คงลอจิกดั้งเดิมของคุณไว้)
  listimg.value = tk_detail.value?.images || [];
  
  const hasPhotoFiles = photoFile.value && photoFile.value.length > 0;
  const hasUploadFile = file_d.value !== null && file_d.value !== undefined;

  // 📸 เคสที่ 1: กรณีผู้ใช้งานทำรายการ "กดถ่ายรูปภาพหลายใบเข้ามาค้างไว้ในระบบ"
  if (hasPhotoFiles) {
    count_success.value = 0;
    err_msg.value = '';

    // 🟢 เปลี่ยนมาใช้ Promise.all วนลูปยิงสตรีมไฟล์รูปถ่ายทั้งหมดขึ้นหลังบ้านพร้อมกันแบบขนาน [INDEX]
    // 💡 (ก่อนส่งเข้าลูป ภาพถ่ายควรถูกเปลี่ยนชื่อด้วย new File เป็นก้อน Binary ในฟังก์ชันเปิดกล้อง/รับรูปถ่ายแล้วนะครับ) [INDEX]
    const uploadRequests = photoFile.value.map(fileItem => uploadfileApi(fileItem));

    try {
      await Promise.all(uploadRequests);
    } catch (e) {
      console.error("Error inside Promise.all in saveMgt:", e);
    }

    // 🟢 เซฟตี้ดักจบ: หากในลูปไม่มีรูปถ่ายใบไหนยิงผ่านฉลุยเลย ให้เด้งเตือนและสั่งหยุดทำงานทันที [INDEX]
    if (count_success.value === 0) {
      return swal("เพิ่มรูปในตั๋วไม่สำเร็จ", err_msg.value || "กรุณาตรวจสอบการเชื่อมต่อไฟล์แนบ", "error");
    }

    // เมื่อรูปถ่ายขนานรันสเตตัสเสร็จสิ้นครบถ้วน วิ่งเข้าฟลูแยกเส้นทางบันทึกข้อมูลหลักตามปกติ
    if (tk_detail.value.uid === '' || tk_detail.value.uid === null) {
      await addMgt();
    } else {
      await updateMgt();
    }

  // 📄 เคสที่ 2: กรณีไม่มีภาพถ่ายจากกล้อง แต่ผู้ใช้เลือกเป็น "ไฟล์แนบปกติเดี่ยวๆ" เข้ามา (file_d.value) [INDEX]
  } else if (hasUploadFile) {
    thumb_id.value = '0';
    
    // 🟢 สั่งรันฟังก์ชัน addfileApi ตัวสะอาดดึงค่าจาก file_d.value โดยตรง และดักรับผล Boolean [INDEX]
    const isUploadSuccess = await addfileApi();
    
    // 🟢 เซฟตี้ดักจบ: หากไฟล์แนบปกติเกิดปัญหาขัดข้อง ให้หยุดตัดจบการทำงานตรงนี้ทันทีเพื่อความปลอดภัย [INDEX]
    if (!isUploadSuccess) {
      return; 
    }

    // เมื่ออัปโหลดส่งสเตตัส 200 ผ่านฉลุยแล้ว ค่อยนำรหัส UID ใหม่ดันลงอาร์เรย์รายการภาพของตั๋ว
    if (thumb_id.value !== '0' && thumb_id.value !== null) {
      listimg.value.push({
        uid: "0",
        imageUid: thumb_id.value,
        remark: ""
      });

      // สั่งรันบันทึกข้อมูลหลักตามสไตล์ฟลูดั้งเดิมของคุณต่อได้เลยครับ
      if (tk_detail.value.uid === '' || tk_detail.value.uid === null) {
        await addMgt();
      } else {
        await updateMgt();
      }
    }

  // 🟢 เคสที่ 3: กรณีผู้ใช้กดบันทึกโดยไม่มีการเปลี่ยนไฟล์แนบและไม่มีการถ่ายรูปใหม่เข้ามาเลย [INDEX]
  } else { 
    if (tk_detail.value.uid === '' || tk_detail.value.uid === null) {
      await addMgt();
    } else {
      await updateMgt();
    }
  }
}




async function addMgt() { 
  let pd = ''
  let dd = ''
  pd = moment(new Date(tk_detail.value.pawnDate)).format('YYYY-MM-DDTHH:mm:ss')
  dd = moment(new Date(tk_detail.value.dueDate)).format('YYYY-MM-DDT00:00:00')
  const payload = tk_detail.value;
  payload.pawnDate = pd
  payload.dueDate = dd
  payload.tkCusUid = cus_detail.value.uid
  payload.tkCusName = cus_detail.value.nameTh
  payload.collaterals = listQ02D.value
  payload.images = listimg.value
  payload.tkVolNo = String(tk_detail.value.tkVolNo)
  payload.tkNo = String(tk_detail.value.tkNo)
  payload.tkRefNumber = String(tk_detail.value.tkRefNumber)
  payload.prevTkVolNo = String(tk_detail.value.prevTkVolNo)
  payload.prevTkNo = String(tk_detail.value.prevTkNo)

  // console.log('addItems p : ' + JSON.stringify(payload));
  const response = await storemgt.mgtAddFetch(payload);
  // console.log('addItems r : ' + JSON.stringify(response.data));
  if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          swal("บันทึกสำเร็จ", "", "success");
          await cancelMgt()
        } else {
          swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
          if (response.data.rtnDesc === 'object already modified') {
            // await clearItem()
            // backToSecondTab()
          }
        }
      }
    }
}


async function updateMgt() {
  let pd = ''
  let dd = ''
  pd = moment(new Date(tk_detail.value.pawnDate)).format('YYYY-MM-DDTHH:mm:ss')
  dd = moment(new Date(tk_detail.value.dueDate)).format('YYYY-MM-DDT00:00:00')
  const payload = tk_detail.value;
  payload.pawnDate = pd
  payload.dueDate = dd
  payload.tkCusUid = cus_detail.value.uid
  payload.tkCusName = cus_detail.value.nameTh
  payload.collaterals = listQ02D.value
  payload.images = listimg.value
  payload.tkVolNo = String(tk_detail.value.tkVolNo)
  payload.tkNo = String(tk_detail.value.tkNo)
  payload.tkRefNumber = String(tk_detail.value.tkRefNumber)
  payload.prevTkVolNo = String(tk_detail.value.prevTkVolNo)
  payload.prevTkNo = String(tk_detail.value.prevTkNo)
 
  // console.log('updateItems p : ' + JSON.stringify(payload));
  const response = await storemgt.mgtUpdateFetch(payload);
  // console.log('updateItems r : ' + JSON.stringify(response.data));
  if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          swal("บันทึกสำเร็จ", "", "success");
          tk_detail.value = response.data.data
          listQ02D.value = response.data.data.collaterals
          tk_detail.value.pawnDate = new Date(moment(tk_detail.value.pawnDate))
          cusUidd_search.value = tk_detail.value.tkCusUid
          cusNamed_search.value = tk_detail.value.tkCusName
          
          listQ02D.value.map(function (x) {
                x.remarkL = []
                return x
          });
          
          for (let i = 0; i < listQ02D.value.length; i++) {
              listQ02D.value[i].remarkL.push({ val: listQ02D.value[i].remark })
          }
          await setCustomerInfo()  
          await calItems() 
        } else {
          swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
          if (response.data.rtnDesc === 'object already modified') {
            // await clearItem()
            // backToSecondTab()
          }
        }
      }
    }
}


async function infoMgt(uid) {
  let data = "";
    data = {
      uid: uid,
  }
  const payload = data; 

  const response = await storemgt.mgtInfoFetch(payload);
  // console.log("infoMgt r : " + JSON.stringify(response.data));  
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          tk_detail.value = response.data.data
          listQ02D.value = response.data.data.collaterals
          tk_detail.value.pawnDate = new Date(moment(tk_detail.value.pawnDate))
          cusUidd_search.value = tk_detail.value.tkCusUid
          cusNamed_search.value = tk_detail.value.tkCusName
                    
          listQ02D.value.map(function (x) {
                x.remarkL = []
                return x
          });
          
          for (let i = 0; i < listQ02D.value.length; i++) {
              listQ02D.value[i].remarkL.push({ val: listQ02D.value[i].remark })
          }
          await setCustomerInfo()  
          await calItems() 
          await onClickTab('2')     
        }
    }
  }

}


async function deleteMgt(item) {
  let data = "";
  data = {
      uid: item.uid,
      version: item.version,
  }
  const payload = data; 
  const response = await storemgt.mgtDeleteFetch(payload);
  // console.log("delMgt r : " + JSON.stringify(response.data));  
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        await loadListApi()
        swal("บันทึกสำเร็จ", "", "success");  
      }else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error")
      }
    }
  }
}

async function addfileApi() {
  if (thumb_id.value && thumb_id.value !== '0') return true;

  const rawFile = file_d.value;
  if (!rawFile || !rawFile.name) return false;

  const payload = {
    files: rawFile, 
    forGroupUid: shop_detail.value.groupUid,
    forShopUid: shop_detail.value.uid,
    publicAccess: false,
  };

  const response = await storedoc.uploadFetch(payload);

  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      const resData = response.data.data;
      let uploadedUid = "";

      if (Array.isArray(resData) && resData.length > 0) {
        uploadedUid = resData[0]?.uid || resData;
      } else if (resData && typeof resData === 'object') {
        uploadedUid = resData.uid || resData;
      } else {
        uploadedUid = resData;
      }

      const cleanUid = String(uploadedUid).trim();

      if (cleanUid !== '' && cleanUid !== 'undefined' && cleanUid !== 'null' && cleanUid !== '[object Object]') {
        
        thumb_id.value = cleanUid; 
        return true; 
      }
      return false;
    } else {
      swal("บันทึกไฟล์ไม่สำเร็จ", response.data.rtnDesc, "error");
      return false;
    }
  } else {
    const errorMsg = response?.data?.rtnDesc || "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
    swal("บันทึกไฟล์ไม่สำเร็จ", errorMsg, "error");
    return false;
  }
}


async function onImgDialog() {
  swal({
    title: "",
    text: "คุณต้องการเพิ่มภาพจาก",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    input: 'select',
    inputOptions: {
      'Camera': 'ถ่ายภาพ',
      'File': 'แนบไฟล์ภาพถ่าย',
    },
    inputPlaceholder: 'กรุณาเลือก',
    inputValidator: function (value) {
      return new Promise(function (resolve, reject) {
        if (value === 'Camera') {
          resolve()
          thumb.value = null
          thumb_att.value = null
          preview.value = ''
          photoFile.value = []
          setFileGallery('photo')
        } else if (value === 'File') {
          thumb.value = null
          thumb_att.value = null
          preview.value = ''
          photoFile.value = []
          file_error_msg.value = "";
          document.getElementById("upload").value = null;
          resolve()
          setFileGallery('file')
        } else {
          resolve("กรุณาเลือกรายการ :)");
        }
      })
    }
  });
}


async function onDeleteDialog(item) {
  swal({
    title: "ยกเลิก",
    text: "คุณต้องการยกเลิกรายการนี้",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      deleteMgt(item)
    }
  });
}

async function showModal() {
  clearItemCollect();
  filterText.value = ''
  dataList.value = []
  listflaw.value = []
  selected.value = ''
  typesNew.value = []
  textt.value = ''
  collIndex.value = -1
  document.getElementById("newPawnModal").click();
}

async function onSelectCollect(item, index) { 
  // console.log('item : ' + JSON.stringify(item));
  collIndex.value = index
  clearItemCollect();
  dataList.value = []
  selected.value = ''
  typesNew.value = []
  textt.value = ''
  collect_detail.value = {
    uid: item.uid,
    ticketUid: item.ticketUid,
    mainCatUid: item.mainCatUid,
    mainCatCode: item.mainCatCode,
    mainCatName: item.mainCatName,
    categoryUid: item.categoryUid,
    categoryCode: item.categoryCode,
    categoryName: item.categoryName,
    weight: item.weight,
    pawnValue: item.pawnValue,
    fullValue: item.fullValue,
    diamondQuantity: item.diamondQuantity,
    quantity: item.quantity,
    unitUid: item.unitUid,
    unitName: item.unitName,
    remark: item.remark,
    collateralGroupUid: item.collateralGroupUid,
    serialNumber: item.serialNumber,
    version: item.version,
    newPawnValue: item.newPawnValue,
    tmpPawnValue: item.tmpPawnValue,
    tmpNewPawnValue: item.tmpNewPawnValue,
  };
  // console.log('setItemDetail : ' + JSON.stringify(collect_detail.value));
  filterText.value = item.categoryName
  if (collect_detail.value.mainCatUid !== '0') {
    await getFlaw(collect_detail.value.mainCatUid)
  }

  document.getElementById("newPawnModal").click();
}

async function openGallery(listimg) {
  images_l.value = listimg
  loading_d.value = true
  images.value = []

  // 1. กรองเอาเฉพาะรายการไฟล์แนบที่มี imageUid จริงๆ (ไม่เป็น "0") มารวมกลุ่มไว้
  const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

  if (validFiles.length > 0) {
    // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload เพื่อส่งเข้าหา API ส่วนกลาง [INDEX]
    const requests = validFiles.map((fileItem) => {
      const payload = {
        groupUid: shop_detail.value.groupUid, // ส่งค่าว่าง หรือดึงจากตัวแปรกรุ๊ปของหน้านี้ (ถ้ามี)
        shopUid: shop_detail.value.uid,  // ส่งค่าว่าง หรือดึงจากตัวแปรไอดีร้านค้าของหน้านี้ (ถ้ามี)
        uid: String(fileItem.imageUid) // รหัสไอดีของไฟล์แนบชิ้นนั้นๆ
      };
      // เรียกใช้ผ่าน Store ส่วนกลางที่แก้เป็น POST + Blob เรียบร้อยแล้ว [INDEX]
      return storedoc.getFileFetch(payload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ เช่น storedoc หรือ stored
    });

    try {
      // 🟢 3. เปลี่ยนมาใช้ Promise.all ยิงดาวน์โหลดทุกไฟล์พร้อมกันแบบขนานรวดเดียว [INDEX]
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        for (let i = 0; i < allResults.length; i++) {
          if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
            const rawData = allResults[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;
              let fileType;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                fileType = 'application/pdf';
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              } else {
                // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน รูปไม่แตก
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                fileType = 'image/jpeg';
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              const originalItem = validFiles[i];

              images.value.push({
                src: dataUrl,
                thumbnailImageSrc: dataUrl,
                alt: '',
                title: fileType, 
                filename: 'attachment_' + originalItem.imageUid, 
                uid: originalItem.uid,
                imageUid: originalItem.imageUid,
                rawBlob: cleanBlob 
              });
            }
          }
        }
      }
    } catch (e) {
      console.error("Error in Promise.all openGallery:", e);
      loading_d.value = false;
      return;
    }
  }

  // 🟢 4. แยกเส้นทางการพรีวิวและดาวน์โหลดตามประเภทไฟล์จริง (ดึงตัวแรกมาตัดสินใจแยกทิศทาง)
  if (images.value.length > 0) {
    const targetFile = images.value[0]; // ดึงวัตถุตัวแรกในคลังมาตรวจสอบสิทธิ์
    const fileType = targetFile.title || "";
    const fileSrc = targetFile.src || "";

    if (fileType === 'application/pdf') {
      // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที ไม่ค้างป๊อปอัปรูปแตก
      loading_d.value = false;
      window.open(fileSrc, '_blank');

    } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
      // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมชื่อที่สั้นและอ่านง่าย
      loading_d.value = false;
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
      let fileNameDownload = `excel_${today}.xlsx`;
      
      const link = document.createElement('a');
      link.href = fileSrc;
      link.setAttribute('download', fileNameDownload);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } else {
      // 🖼️ กรณีเป็นรูปภาพปกติ -> รันเปิดตัวพรีวิวและสั่งคลิกเปิดกล่องป๊อปอัปหน้าเดิมตามดีไซน์ของคุณ
      setGallery()
      loading_d.value = false
      await nextTick();
      document.getElementById("myModalClose").click(); // ไอดีคำสั่งเปิดดั้งเดิมตรงตามรูปภาพของคุณ
    }
  } else {
    loading_d.value = false;
    swal('Record not found', "", "error");
  }
}


function setGallery() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {

    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo1").innerHTML = y;
}

async function openTab(uid) { 
  datas.hide = false;
    if (Listdata.value.length === 0) {
      await loadDataApi();
    }
  
    if (listprint.value.length === 0) {
      await loadDataPrintApi()
    }
  
    if (listunit.value.length === 0) {
      await loadDataUnitApi()
    }
  
    if (shop_detail.value === null) {
      await cashAccShopApi()
    }
  
    if (listCountry.value.length === 0) {
      await loadCountryListApi()
    }
  
    if (listProvince.value.length === 0) {
      await loadProvinceListApi()
    }

    await infoMgt(uid)
 }


 async function getCustomerInfo(uid) {
  let data = "";
  data = {
    uid: uid,
  };
  const payload = data;
  const response = await storecus.customerInfoFetch(payload);
  // console.log("CustomerInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        cus_detail.value = response.data.data
        cusUidd_search.value = cus_detail.value.uid
        cusNamed_search.value = cus_detail.value.nameTh
        if (cus_detail.value.cusShop === null) {
          swal("ไม่พบข้อมูลลูกค้าสาขา", '', "error");
        }
      }
    }
  }
}


async function setFileGallery(val) {
  // บังคับเคลียร์/โหลดข้อมูลอาร์เรย์รูปภาพตามโครงสร้างเดิมของคุณ
  images_l.value = tk_detail.value?.images || [];
  images.value = [];
  loading.value = true;

  // 1. กรองเอาเฉพาะรายการไฟล์แนบที่มี imageUid จริงๆ (ไม่เป็น "0") มารวมกลุ่มไว้
  const validFiles = images_l.value.filter(file => file.imageUid && file.imageUid !== "0");

  if (validFiles.length > 0) {
    // 🟢 2. วนลูปสร้าง Requests ในรูปแบบ POST Payload เพื่อส่งเข้าหา API ส่วนกลาง [INDEX]
    const requests = validFiles.map((fileItem) => {
      const payload = {
        groupUid: shop_detail.value.groupUid, // ส่งค่าว่าง หรือดึงจากตัวแปรกรุ๊ปของหน้านี้ (ถ้ามี)
        shopUid: shop_detail.value.uid,  // ส่งค่าว่าง หรือดึงจากตัวแปรไอดีร้านค้าของหน้านี้ (ถ้ามี)
        uid: String(fileItem.imageUid) // รหัสไอดีของไฟล์แนบชิ้นนั้นๆ
      };
      // เรียกใช้ผ่าน Store ส่วนกลางที่แก้เป็น POST + Blob เรียบร้อยแล้ว [INDEX]
      return storedoc.getFileFetch(payload); // 💡 ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ เช่น storedoc หรือ stored
    });

    try {
      // 🟢 3. เปลี่ยนมาใช้ Promise.all ยิงดาวน์โหลดทุกไฟล์พร้อมกันแบบขนานรวดเดียว [INDEX]
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        for (let i = 0; i < allResults.length; i++) {
          if (allResults[i] && allResults[i].status === 200 && allResults[i].data !== null) {
            const rawData = allResults[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // สแกนตรวจสอบเนื้อไฟล์จริง (Magic Numbers)
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;
              let fileType;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
                fileType = 'application/pdf';
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              } else {
                // 🖼️ สลัดหัวคำสั่งดาวน์โหลดทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน รูปไม่แตก
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
                fileType = 'image/jpeg';
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              const originalItem = validFiles[i];

              images.value.push({
                src: dataUrl,
                thumbnailImageSrc: dataUrl,
                alt: '',
                title: fileType, 
                filename: 'attachment_' + originalItem.imageUid, 
                uid: originalItem.uid,
                imageUid: originalItem.imageUid,
                rawBlob: cleanBlob 
              });
            }
          }
        }
      }
    } catch (e) {
      console.error("Error in Promise.all setFileGallery:", e);
      loading.value = false;
      return;
    }
  }

  // 🟢 4. เคลียร์ค่าคลังสำรองในกรณีที่ไม่มีข้อมูลภาพหลุดรอดเข้ามาเลย
  if (images.value.length === 0) {
    images.value.push({
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    });
  }

  // 🟢 5. แยกเส้นทางการพรีวิวและดาวน์โหลดในกรณีที่เจอไฟล์ PDF หรือ Excel (หยิบตัวแรกมาตรวจสอบทิศทาง)
  const targetFile = images.value[0];
  const fileType = targetFile.title || "";
  const fileSrc = targetFile.src || "";

  if (fileType === 'application/pdf') {
    // 📄 กรณีเป็น PDF -> ดีดเปิดแท็บใหม่ทันที ไม่ค้างป๊อปอัปรูปแตก
    loading.value = false;
    window.open(fileSrc, '_blank');
    return; // ตัดจบฟลู

  } else if (fileType.includes('spreadsheetml') || fileType.includes('excel')) {
    // 📊 กรณีเป็น Excel -> สั่งดาวน์โหลดลงเครื่องทันทีพร้อมชื่อที่สั้นและอ่านง่าย
    loading.value = false;
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
    let fileNameDownload = `excel_${today}.xlsx`;
    
    const link = document.createElement('a');
    link.href = fileSrc;
    link.setAttribute('download', fileNameDownload);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return; // ตัดจบฟลู
  }

  // 🟢 6. รันฟลูจัดการแยกเส้นทางพรีวิวตามพารามิเตอร์ของหน้านี้ (photo = เปิดกล้อง / file = เปิด Modal พรีวิว)
  loading.value = false;

  if (val === 'photo') {
    let ref = '-';
    let dtL = [];
    
    // แกะเช็คคีย์สเปกของหน้านี้อย่างปลอดภัยจาก tk_detail.value.tkRefNumber
    if (tk_detail.value?.tkRefNumber !== '' && tk_detail.value?.tkRefNumber !== null && tk_detail.value?.tkRefNumber !== undefined) {
      ref = String(tk_detail.value.tkRefNumber);
    }
    
    let obj = {
      cusnameTh: cus_detail.value?.nameTh || '',
      refnumber: ref
    };
    
    dtL.push(obj);
    localStorage.setItem("dataL", JSON.stringify(dtL));
    localStorage.setItem("imageL", JSON.stringify(images.value));
    openCamera(); // สั่งเปิดโมดูลกล้องถ่ายรูป

  } else if (val === 'file') {
    await nextTick();
    document.getElementById("attachmenDialog").click(); // คลิกเปิด Modal แสดงพรีวิวคลังรูปภาพปกติ
  }
}


function compressCapturedImage(fileBlob) {
  return new Promise((resolve) => {
    const safeBlob = fileBlob instanceof Blob ? fileBlob : new Blob([fileBlob], { type: 'image/jpeg' });
    const reader = new FileReader();
    reader.readAsDataURL(safeBlob);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width || 1280;
        let height = img.height || 720;
        if (width > 2540) {
          const scale = 2540 / width;
          width = 2540;
          height = height * scale;
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((compressedBlob) => {
          resolve(compressedBlob || safeBlob);
        }, 'image/jpeg', 0.8);
      };
      img.onerror = () => resolve(safeBlob);
    };
    reader.onerror = () => resolve(safeBlob);
  });
}

// 🟢 2. ฟังก์ชันพิเศษคุ้ยแกะสตริง Base64 ดักสแกนลึกทุกซอกมุมของวัตถุกล้องที่ส่งมามั่ว
function findBase64StringDeep(obj) {
  if (!obj) return null;
  if (typeof obj === 'string' && (obj.startsWith('data:') || obj.length > 100)) {
    return obj;
  }
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const result = findBase64StringDeep(obj[i]);
      if (result) return result;
    }
  }
  if (typeof obj === 'object') {
    const keys = ['filedt', 'file', 'result', 'src', 'dataData', 'target'];
    for (const key of keys) {
      if (obj[key]) {
        const result = findBase64StringDeep(obj[key]);
        if (result) return result;
      }
    }
    for (const k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) {
        const result = findBase64StringDeep(obj[k]);
        if (result) return result;
      }
    }
  }
  return null;
}

async function uploadfileApi(image) {
  if (!image) return false;

  let fileBlob = null;
  
  // 📌 ด่านที่ 1: เรียกเครื่องคุ้ยสแกนระดับลึก คุ้ยหาข้อความภาพ Base64 จากเศษวัตถุ Proxy กล้องที่ซ้อนมั่วหลุดเข้ามา [1]
  let extractedBase64 = findBase64StringDeep(image);

  if (extractedBase64 && typeof extractedBase64 === 'string') {
    const base64Clean = extractedBase64.includes(',') ? extractedBase64.split(',') : [extractedBase64];
    try {
      const rawString = base64Clean[base64Clean.length - 1].trim();
      const byteCharacters = atob(rawString);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      fileBlob = new Blob([byteArray], { type: 'image/jpeg' });
    } catch (e) {
      console.error("Base64 decoding failed in uploadfileApi, fallback", e);
      fileBlob = new Blob([extractedBase64], { type: 'image/jpeg' });
    }
  } else {
    fileBlob = image instanceof Blob ? image : new Blob([image], { type: 'image/jpeg' });
  }

  // 📌 ด่านที่ 2: ส่งเข้าเครื่องบีบอัดลดขนาดภาพถ่ายอัตโนมัติทันทีบนเบราว์เซอร์ หากใบไหนน้ำหนักความจุเกิน 10 MB [1]
  const maxSize = 10 * 1024 * 1024;
  if (fileBlob && fileBlob.size > maxSize) {
    console.log(`รูปถ่ายใบนี้ขนาด ${fileBlob.size} bytes เกิน 10 MB ระบบกำลังสั่งบีบอัดลดขนาด...`);
    fileBlob = await compressCapturedImage(fileBlob);
  }

// ฟังก์ชันแปลงหน่วยอัจฉริยะ (KB หรือ MB ตามจริง)
// const formatFileSize = (bytes) => {
//   if (bytes < 1024 * 1024) {
//     return `${(bytes / 1024).toFixed(2)} KB`;
//   }
//   return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
// };

// // นำไปใช้งาน
// console.log(`รูปถ่ายใบนี้ขนาด ${formatFileSize(fileBlob.size)} ก่อนบีบอัดลดขนาด...`);

// fileBlob = await compressCapturedImage(fileBlob);

// console.log(`รูปถ่ายใบนี้ขนาด ${formatFileSize(fileBlob.size)} หลังบีบอัดลดขนาด...`);

  let today = moment(new Date()).local().format('YYYYMMDD_HHmmss');
  let finalFileName = image.name || `camera_${today}.jpg`;

  const renamedFile = new File([fileBlob], finalFileName, {
    type: 'image/jpeg',
    lastModified: new Date().getTime()
  });

  // เครื่องสกรีนดักความปลอดภัยขั้นต่ำ (ดักจับขนาด bytes ดิบ ป้องกันเศษข้อมูลขยะหลุดรอด) [1]
  if (!renamedFile || renamedFile.size < 100) {
    console.warn("🛑 บล็อกล่วงหน้า! ตรวจพบไฟล์ไม่มีเนื้อข้อมูลพิกเซลรูปภาพ:", renamedFile?.size);
    return false;
  }

  const payload = {
    files: renamedFile, // ส่งก้อนเนื้อไฟล์ไบนารี File Object ชิ้นสมบูรณ์ที่ขนาดปลอดภัยชัวร์ขึ้นหลังบ้าน [1]
    forGroupUid: "",
    forShopUid: "",
    publicAccess: true,
  };

  try {
    const response = await storedoc.uploadFetch(payload);

    if (response && response.status === 200 && response.data.rtnDesc === "success") {
      const dataContent = response.data.data; 
      let currentThumbId = "";

      // เจาะแกะรหัสผ่านชั้นเลเยอร์ Array จริงหลังบ้าน [1]
      if (Array.isArray(dataContent) && dataContent.length > 0) {
        currentThumbId = dataContent[0]?.uid || dataContent;
      } else if (dataContent && typeof dataContent === 'object') {
        currentThumbId = dataContent.uid || "";
      } else {
        currentThumbId = dataContent;
      }

      const cleanUid = String(currentThumbId).trim();

      if (cleanUid !== '' && cleanUid !== 'undefined' && cleanUid !== 'null' && cleanUid !== '[object Object]') {
        thumb_id.value = cleanUid;
        listimg.value.push({
          uid: "0",
          imageUid: cleanUid,
          remark: ""
        });
        count_success.value++; 
        return true; 
      }
    }
  } catch (err) {
    console.error("Error inside uploadfileApi:", err);
  }
  return false;
}

async function cancelMgt() { 
  cusUidd_search.value = ''
  cusNamed_search.value = ''
  clearItemCustomerInfo();
  clearItemTk();
  clearItemCollect()
  addMonths()
}


async function clearItemCustomerInfo() {
  cus_detail.value = {
    uid: '',
    nameTh: '',
    nameEn: '',
    birthOrRegDate: new Date(),
    address: {
      address1: "",
      subDistrict: "",
      district: "",
      province: "",
      postcode: "",
      country: ""
    },
    issuedDate: new Date(),
    expiredDate: new Date(),
    version: '',
    age: 0,
    docTypeUid: '0',
    docNumber: '',
    cusShop: {
      cusTypeUid: "0",
      creditAmount: 0,
      email: "",
      phoneNo1: "",
      phoneNo2: "",
      phoneNo3: "",
      fingerPrint1Uid: "0",
      fingerPrint2Uid: "0",
      fgTemplate1Uid: "0",
      fgTemplate2Uid: "0",
      warningMsg: "",
      notifyWarning: false,
    }
  }
}

async function clearItemTk() { 
  tk_detail.value = {
    uid: "",
    tkVolNo: "",
    tkNo: "",
    txType: "", // PAWN, INTEREST, DEC_PRINCIPLE, INC_PRINCIPLE
    tkRefNumber: "",
    pawnDate:  new Date(new Date().setHours(0, 0, 0)),
    pawnValue:  "",
    fullValue:  "",
    interest:  "",
    dueDate: new Date(),
    quantity: "",
    prevTkVolNo: "",
    prevTkNo: "",
    tkCusUid: "",
    version: "",
    collaterals: [],
    images:[],
  }
  images.value = []
  images_l.value = []
  listimg.value = []
  thumb.value = null
  mimeType.value = ''
  thumb_att.value = null
  thumb_id.value = '0'
  thumb_name.value = ''
  preview.value = ''
  photoFile.value = []
  listQ02D.value = []
  balprice.value = 0;
  balfull.value = 0;
  balquanity.value = 0;
  cansave.value = false
}

async function clearItemCollect() {
  collect_detail.value = {
  uid: '',
  ticketUid: '',
  mainCatUid: '0',
  mainCatCode: '',
  mainCatName: '',
  categoryUid: '',
  categoryCode: '',
  categoryName: '',
  weight: '',
  pawnValue: '',
  newPawnValue: '',
  tmpPawnValue: '',
  tmpNewPawnValue: '',
  fullValue: '',
  diamondQuantity: '',
  quantity: '',
  unitUid: '0',
  unitName: '',
  remark: '',
  collateralGroupUid: '',
  version: '',
  serialNumber: '',
 }
}

async function cansaveMgt() { 
  let can = false;

  if (cus_detail.value.uid === null|| cus_detail.value.uid === '') {
    can = true
  }

  if (cus_detail.value.nameTh === null || cus_detail.value.nameTh === '') {
    can = true
  }

  if (tk_detail.value.tkVolNo === null || tk_detail.value.tkVolNo === '') {
    can = true
  }

  if (tk_detail.value.tkNo === null || tk_detail.value.tkNo === '' ) {
    can = true
  }

  if (tk_detail.value.txType === null || tk_detail.value.txType === '' ) {
    can = true
  }

  if (tk_detail.value.tkRefNumber === null || tk_detail.value.tkRefNumber === '') {
    can = true
  }

  if (tk_detail.value.pawnDate === null || tk_detail.value.pawnDate === '') {
    can = true
  }

  if (tk_detail.value.pawnValue === null || tk_detail.value.pawnValue === '' || tk_detail.value.pawnValue === 0) {
    can = true
  }

  if (tk_detail.value.fullValue === null || tk_detail.value.fullValue === '' || tk_detail.value.fullValue === 0) {
    can = true
  }

  if (tk_detail.value.interest === null || tk_detail.value.interest === '' || tk_detail.value.interest === 0) {
    can = true
  }

  if (tk_detail.value.quantity === null || tk_detail.value.quantity === '' || tk_detail.value.quantity === 0) {
    can = true
  }

  if (tk_detail.value.dueDate === null || tk_detail.value.dueDate === '') {
    can = true
  }

  // console.log('cansave : ' + can);
  cansave.value = can
}


onUpdated(() => {
  updateWidths();
  updateText()

})


onMounted(() => {
  updateWidths();
  window.addEventListener('resize', updateWidths);

    if (document.getElementById("tab1-tab")) {
        document.getElementById("tab1-tab").classList.add('show', 'active')
    }

    if (document.getElementById("tab1")) {
        document.getElementById("tab1").classList.add('show', 'active')
    }
});


</script>
<style lang="scss" scoped>
.review {
  border: 2px solid #1a73e8;
  border-radius: 6px;
  background: #d9e9ff;
}

.grid-container {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.btnClose {
  border-color: transparent !important;
  background-color: white !important;
  vertical-align: baseline;

  i.material-icons {
    padding-top: 8px;
    color: gray-600;
  }
}

.left {
  display: flex;
  justify-content: flex-end;
  margin-right: auto;
  margin-left: 0;
}

.inline-icon {
  display: inline-flex;
  vertical-align: top;
  font-size: 28px !important;
}

.error {
  font-weight: bold;
  color: red;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-containerB {
  max-width: 990px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1f;
}


.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  top: -18px;
  right: -23px;
  z-index: 2;
  font-size: 20px;
}
</style>